import { Component, OnInit, ViewChild, Input, Output } from '@angular/core';
//Librerias para el campo de color
import { ColorPickerService, Cmyk } from 'ngx-color-picker';
import { ViewContainerRef } from '@angular/core';

//Enrutamiento
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
//Alertas
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
//Datalist
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
//Formularios
import {NgForm} from '@angular/forms';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
//Ventana Modal
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
//Calendar
import { FullCalendarModule, CalendarComponent } from 'ng-fullcalendar';
import { Options } from 'fullcalendar';

//Acordeon
import {AccordionModule} from "ng2-accordion";

//Servicios
import { ConfigService } from '../../servicios/config/config.service';
import { NotadetallepqrService } from '../../servicios/pqr/notadetallepqr.service';
import { KeyService } from '../../servicios/key.service';
import { ValidService } from '../../servicios/valid.service';
import { AgendamientoAppService } from '../../servicios/agendamiento-app/agendamiento-app.service';
import { TercerosService} from '../../servicios/terceros/terceros.service';
import { SucursalService } from '../../servicios/Terceros/sucursal.service';
import { EquipoTerceroService } from '../../servicios/equipos/equipo-tercero.service';
import { TiposervicioService } from '../../servicios/pqr/tiposervicio.service';
import { EstadopqrService } from '../../servicios/pqr/estadopqr.service';
import { PqrService } from '../../servicios/pqr/pqr.service';
import { AlertapqrService } from '../../servicios/pqr/alertapqr.service';
import { TratamientopqrService } from '../../servicios/pqr/tratamientopqr.service';
import { TecnicoasignadopqrService } from '../../servicios/pqr/tecnicoasignadopqr.service';
import { UsuariosService } from '../../servicios/usuarios/usuarios.service';
import { RastreoService } from '../../servicios/rastreo/rastreo.service';
import { TratamientoPqrComponent } from './../pqr/tratamiento-pqr/tratamiento-pqr.component';
import { PerfilesService } from '../../servicios/perfiles/perfiles.service';
import { TipopqrService     } from '../../servicios/pqr/tipopqr.service';
import { PrioridadService } from '../../servicios/pqr/prioridad.service';
import { ContactosService         } from '../../servicios/Terceros/contactos.service';
import { VersionequipoService } from '../../servicios/versiones/versiones.service';

import { EventosJqueryService } from '../../servicios/eventos-jquery/eventos-jquery.service';
//configuración del idioma de los datapicker
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
defineLocale('es', esLocale);
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { FiltrosService } from '../../servicios/filtro/filtros.service';
import { DatatablesService } from '../../servicios/datatable/datatables.service';
import { timeout } from 'rxjs/operator/timeout';

//Declaracion de variable global para usar jQuery
declare var $: any;

@Component({
  selector: 'app-agendamiento-app',
  templateUrl: './agendamiento-app.component.html',
  styleUrls: ['./agendamiento-app.component.css'],
  providers:[
      TipopqrService,
      AgendamientoAppService,
      TercerosService,
      SucursalService,
      EquipoTerceroService,
      TiposervicioService,
      EstadopqrService,
      PqrService,
      AlertapqrService,
      TratamientopqrService,
      TecnicoasignadopqrService,
      UsuariosService,
      RastreoService,
      TratamientoPqrComponent,
      PerfilesService,
      TipopqrService,
      EventosJqueryService,
      NotadetallepqrService,
      BsModalService,
      PrioridadService,
      ContactosService,
      VersionequipoService,
      FiltrosService,
      DatatablesService
  ]
})
export class AgendamientoAppComponent implements OnInit {
  Filtros      = 'Filtros';
  editarFiltro : any = false;
  modulo : any = 'filtro';
  dTFiltros    : any;

  hidecontacto = false;
  language = {
    lengthMenu: "Mostrar _MENU_ registros por página.",
    zeroRecords: "No se ha encontrado ningún registro.",
    info: "Mostrando _START_ a _END_ de _TOTAL_ entradas.",
    infoEmpty: "Registros no disponibles.",
    search   : "",
    searchPlaceholder: "Buscar",
    loadingRecords: "Cargando...",
    processing:     "Procesando...",
    paginate: {
      first:      "Primero",
      last:       "Último",
      next:       "Siguiente",
      previous:   "Anterior"
    },
    infoFiltered: "(_MAX_ Registros filtrados en total)"
  };

  columnas = {
		columns: [1,2]
  };

  buttons = [
    { extend:'excel',className:'excelButton', text:'Excel',   exportOptions:this.columnas},
    { extend:'copy', className:'excelButton', text:'Copiar',  exportOptions:this.columnas},
    { extend:'csv',  className:'excelButton', text:'CSV',     exportOptions:this.columnas},
    { extend:'pdf',  className:'pdfButton',   text:'PDF',     exportOptions:this.columnas},
    { extend:'print',className:'printButton', text:'Imprimir',exportOptions:this.columnas}
  ];

  tiposprioridad        : any;
  versionesEquipo       : any;

  itemequipoidpqr       : any;
  mostrarBotonRefreshCierreActividad : boolean = false;
  disabledCierreCactividad           : boolean = false; //habilita o deshabilita el boton guardar cierre actividades
  estadotablacerrarActividad         : any;
  validaIncCierre                    : any;
  urls_archivos        = [];
  tipo_archivos        = [];
  notaArray            : any[]; //listado de notas del detalle de una pqr
  archivonotaArray     : any[]; //listado de archivos de las notas del detalle de una pqr
  dataAutorizo         : any;
  mostrarasignar       : boolean = false;
  cumplida             : boolean = false;
  disabledReabrir      : boolean = false;
  id_detallepqr        : any; //Variable que maneja el id del detalle de la PQR
  dtpqrArray           : any[]; //listado de detalles de una pqr
  mostrarBotonRefresh  : boolean = false;
  listaTipoActividad   = new Array();
  tecnicosCierre       = new Array();
  usuarioCliente       : any;   //valida si el usuario es cliente
  detallepqriid        : any;
  eventoclic           : any = 0;
  listpermisos         : any;
  mostrarpreloaderpri  : any = true;
  dataArryEquipo       = new Array();
  //Obtener datos del usuario del storage
  getUsuarioId         : any = localStorage.getItem('usuarioid');
  idperfil             : any = localStorage.getItem('idperfil'); // almacena el el perfil del usuario para vaklidar si es de tipo C es cliente
  getCedulaUsuario     : any = localStorage.getItem('cedulaUsuario');
  formBusqueda         : FormGroup;
  formNotas            : FormGroup;

  //Calendar
  calendarOptions      : Options;
  @ViewChild(CalendarComponent) ucCalendar : CalendarComponent;

  //Parametro enviado desde tramiento pqr
  @Input() pqrid: string;
  identificadorAgenda  : any;

  //Variables para datatable
  order: string = 'info.name';
  reverse: boolean = false;
  sortedCollection: any[];
  data = new Array();
  dataOpercionid         = new Array();
  dataVersionid          = new Array();
  listCoordinador       : any[]; //Listado de coordinadores
  listProveedor         : any[]; //Listado de coordinadores
  listTecnico           : any[]; //Listado de tecnicos
  listatecnicossegur    = new Array();
  listTecnico_aux       = new Array();
  Tecnicoslist          = new Array();
  TecnicoList           = new Array();
  listoperaciones       = new Array();
  texto                 : any;
  formFiltros           : FormGroup; //formulario de filtros
  formNuevaprogramacion : FormGroup;
  modalRef              : BsModalRef; //Ventana modal
  accion                : string = '' //Accion para Crear o Editar
  mostrarCampo          : boolean = false; //muestra u oculta un campo
  mostrarBotonHabilitarModificar  : boolean = false; //muestra u oculta boton
  disabledcampo         : boolean = true; //habilita o deshabilita un campo
  disabledBtnGuardar    : boolean = false; //habilita o deshabilita el boton guardar
  tiposervicios         : any; //listado de tipos de servicio
  estadospqr            : any; //listado de tipos de estado pqr
  transicionestado      = new Array();
  tipopqr               : any; //listado de tipos de pqr
  clientes              : any; //listado de clientes
  sindatos              = '';
  disabled              : boolean = false;
  consecutivoTecnicoAsignadoPqr : any;
  mensajeError          : any;
  mostrarpreloader      : boolean = false;
  mostrarcalendar       : boolean = true;
  mostrarBotonCrearAgenda : boolean = false;
  tecnicoagendamientoArray   = new Array();
  tecnicoagendamientoArray_aux :any[];
  estadosnombreArray    : any[];
  serviciosArray        : any[];
  clienteArray          : any[];
  equipoArray           : any[];
  sucursalArray         : any[];
  coordinadorArray      : any[];
  tecnicoArray          : any[];
  familiaActividad      = new Array();
  totalActividades      = new Array(); // total actividades segun falia

  //filtros multiples
  statesClienteFiltros       = new Array();
  statesNombrComerFiltros    = new Array();
  statesSucursalFiltros      = new Array();
  statesFamiliaFiltros       = new Array();
  statesEquipoFiltroMultiples= new Array();
  statesMarcaFiltros         = new Array();
  statesAdquisicionFiltro    = new Array();
  statesEstadoFiltros        = new Array();
  statesTipoServicioFiltros  = new Array();
  statesPrioridadFiltros     = new Array();
  statesTecnicoFiltros       = new Array();

  //DATALIST  DE CREACION
  statesCliente              = new Array();
  statesTecnicoid            = new Array();
  statesSucursal             = new Array();
  statesEquipoFiltro         = new Array();
  statesPqr                  = new Array();
  statesFamiliaFiltro        = new Array();
  statesMarca                = new Array();
  statescodigointernoFiltro  = new Array();
  statesTicket               = new Array();
  statesPrioridad            = new Array();

  contactos                  = new Array();

  statesClienteCrearl        = new Array();
  statesSucursalCrear        = new Array();
  statesEquipoCrear          = new Array();
  statesOperacion            = new Array();
  selectedOptionCliente      : any;
  selectedOptionSucursal     : any;
  selectedOptionEquipo       : any;
  noResultCliente            = false;
  noResultSucursal           = false;
  noResultEquipo             = false;
  noResultOperacion          = false;
  listactividadesFamilia     = new Array();
  totalActividadesFamilia    = new Array();
  mostraropcionModal         : boolean = true;
  statesTecnico              = new Array();
  selectedOptionTecnico      : any;
  campos                     = [{'id': 'campo1'}]; //Arreglo inicial para agregar campos dinamicos
  cantidadcampos             : any = 1;            //Guardar la cantidad de campos agregados
  cantidadcamposasignados    : any; //Variable para almacenar la cantidad de campos de los tecnicos asignados
  activarAdicionarCampos     : boolean = true;
  tapqrArray                 : any[]; //listado de tecnicos asignados
  arrayAgregarTecnicos       = new Array();
  listTecnicoporCordinador   = new Array();//listado de tecnicos por coordinador
  listcoordinadores_aux      = new Array();//listado de otros coordinadores

  tecnicoscoordinadores_aux  = new Array();
  tecnicosotroscoordinadores = new Array();
  tecnicoscoordinadores      : any; //Listado de tecnicos por coordinador

  estadofechainc             : any; //Variable para permitir visualizar la fecha de la incidencia
  estadoactividadincidencia  : any; //Variable para permitir visualizar las actividades de la incidencia
  fichatecnica               : any; //Variable para permitir visualizar las fichas tecnicas y campos operacion en incidencia,tratamiento , operacion
  validaticket               : any; //Variable para permitir visualizar campo numero de ticket en incidencia
  ismeridian                 : boolean = true;
  tipomantenimiento          : any;
  incconelineaconta          : any;
  incconelineainven          : any;
  servidorbdconta            : any;
  basedatosconta             : any;
  usuarioconta               : any;
  claveconta                 : any;
  servidorbdinven            : any;
  basedatosinven             : any;
  usuarioinven               : any;
  claveinven                 : any;
  clonarinc                  : any;
  tipoinventario             : any;
  agendaautomatica           : any;
  servicio                   : any;
  tercerocreacionincidencia  : any;
  nombrcomer                 : any;
  razonsocial                : any;
  estadoincidencia           : any;
  nombretercero              : any;
  listcoordinadoresOtros_aux = new Array();
  contenidoFechas            : any;
  coordinadores              = new Array(); //Listado de coordinadores

  //Filtros
  filtros = {
    fecha_de_creacion_inc : '', fecha_final: '', nombre_tecnico: ''
  }
  //Busquedas
  busquedasfilter = {
    pqrid              : null
    ,tecnicoid         : null
    ,clienteid         : null
    ,sucursalid        : null
    ,itemequipoid      : null
    ,familiaid         : null
    ,marcaid           : null
    ,tipoadquisicionid : null
    ,codigointerno     : null
    ,ticket            : null
    ,estadoid          : null
    ,servicioid        : null
    ,prioridadid       : null
    ,nombcomer         : null
    ,fechainicial      : ''
    ,fechafinal        : ''
  }

  //Formulario Nueva Programacion
  nuevaprogramacion = {
     agendamientoid          : '' , tipomantenimientoid : '', fecha                     : '', horainicial           : '', horainicialaux  : ''
    ,horafinal               : '' , ticket              : '', pqrid                     : '', estado                : '', terceroid       : ''
    ,sucursalid              : '' , equipoterceroid     : '', asunto                    : '', tiposervicioid        : '', estadopqrid     : ''
    ,tipopqrid               : null, coordinadorid       : '', tecnicoagendamiento       : this.tecnicoagendamientoArray , descripcion     : ''
    ,fechaagendaid           : '' , detallepqrid        : '', alertapqrid               : '', fechafinal            : '', prioridadid     : ''
    ,colorhexadecimal        : '' , serial              :'' , cierre                    : '', actividadid           : this.totalActividadesFamilia
    ,validadoperaciontiempo  : '' , operacionid         : '', tipomantenimientoid_aux   : '', fecha_aux             : '', horainicial_aux : ''
    ,horafinal_aux           : '' , pqrid_aux           : '', estado_aux                : '', terceroid_aux         : '', sucursalid_aux  : ''
    ,equipoterceroid_aux     : '' , asunto_aux          : '', tiposervicioid_aux        : '', estadopqrid_aux       : '', tipopqrid_aux   : ''
    ,coordinadorid_aux       : '' , descripcion_aux     : '', fechafinal_aux            : '', prioridadid_aux       : '', colorhexadecimal_aux : ''
    ,estadopqridnombre_aux   : '' , servicionombre      : '', nombrecliente             : '', nombreequipo          : '', nombresucursal  : ''
    ,nombretecnico           : '' , nombrecoordinador   : '', unidad_medida             : '', valor_frecuencia      : '1',cantidad_inc    : '1'
    ,dependenciaid           : '' , otrocoordinadorid   : '', valorfrecuencia           : '', tiempo                : '' ,esproveedor     : null
    ,esproveedor_aux         :null, presupuestoplaneado : null,presupuestoplaneado_aux  : null
    ,contactoid              : '' , versionid           : ''
    ,pqrarelacionar          : '' , nombrcomer          : '', razonsocial               : '', nversion : ''
    ,cambiaversionactual     : '' , visibpublic         : true, visibprivad            : false,visibilidad : 0
  }
  NombreCliete : any;

  agendartodotiposervicio : any;

  //Objeto para Detalle PQR
  detallepqr = {
    pqrid             : '',
    fecha             : '',
    estadopqr         : '',
    colorhexadecimal  : '',
    detalle           : '',
    files             : '',
    estadopqrid       : '',
    archivosanexos    : '',
    cumplido          : '',
    detallepqr        : ''
  }

  //Horas
  horas = [
    "00:00",  "00:30",  "01:00",  "01:30",  "02:00",  "02:30",  "03:00",  "03:30",  "04:00",  "04:30",  "05:00",  "05:30",
    "06:00",  "06:30",  "07:00",  "07:30",  "08:00",  "08:30",  "09:00",  "09:30",  "10:00",  "10:30",  "11:00",  "11:30",
    "12:00",  "12:30",  "13:00",  "13:30",  "14:00",  "14:30",  "15:00",  "15:30",  "16:00",  "16:30",  "17:00",  "17:30",
    "18:00",  "18:30",  "19:00",  "19:30",  "20:00",  "20:30",  "21:00",  "21:30",  "22:00",  "22:30",  "23:00",  "23:30"
  ];

  fechaArray = ['1']
  dtTblInsumos        :any;
  dtTblrelacionheadpqr:any;
  arrayAsignacion     = new Array();
  saldoconsumo        : any;
  noResultcosto       = false;

  totalOperaciones    : any = 0;

  primaestado         : any;
  estadopqridCliente  : '';
  procesorequisicion  : '';
  nombreestadocliente : '';
  observacionCliente  : '';
  validaversion = false;
  mostrarFiltro = false;
    //Declaraciones para el campo de color
    public toggle: boolean = false;
    public rgbaText: string = 'rgba(165, 26, 214, 0.2)';
    public arrayColors: any = {
      color1: '#2883e9',
      color2: '#e920e9',
      color3: 'rgb(255,245,0)',
      color4: 'rgb(236,64,64)',
      color5: 'rgba(45,208,45,1)'
    };
    public selectedColor: string = 'color1';
    public color1: string = '#2889e9';
    public color2: string = '#e920e9';
    public color3: string = '#fff500';
    public color4: string = 'rgb(236,64,64)';
    public color5: string = 'rgba(45,208,45,1)';
    public color6: string = '#1973c0';
    public color7: string = '#f200bd';
    public color8: string = '#a8ff00';
    public color9: string = '#278ce2';
    public color10: string = '#0a6211';
    public color11: string = '#f2ff00';
    public color12: string = '#f200bd';
    public color13: string = 'rgba(0, 255, 0, 0.5)';
    public color14: string = 'rgb(0, 255, 255)';
    public color15: string = '#a51ad633';
    public color16: string = 'rgba(45,208,45,0.5)';
    public cmykColor: Cmyk = new Cmyk(0, 0, 0, 0);

  //Constructor
  constructor(
    public vcRef                : ViewContainerRef,
    private cpService           : ColorPickerService,
    private _config             : ConfigService,
    private _valid              : ValidService,
    private _key                : KeyService,
    private _agendamiento       : AgendamientoAppService,
    private _terceros           : TercerosService,
    private _sucursal           : SucursalService,
    private _equipoTercero      : EquipoTerceroService,
    private route               : ActivatedRoute,
    private router              : Router,
    private toastr              : ToastrService,
    private modalService        : BsModalService,
    private _tiposervicio       : TiposervicioService,
    private _estadopqr          : EstadopqrService,
    private _pqr                : PqrService,
    private _alertapqr          : AlertapqrService,
    private _tratamientopqr     : TratamientopqrService,
    private _tecnicoasignadopqr : TecnicoasignadopqrService,
    private _usuarios           : UsuariosService,
    private _rastreo            : RastreoService,
    private _perfiles           : PerfilesService,
    private _tipopqr            : TipopqrService,
    private _evtjq              : EventosJqueryService,
    private _notadetallepqr     : NotadetallepqrService,
    private _prioridad          : PrioridadService,
    private _contacto           : ContactosService,
    private _versiones          : VersionequipoService,
    private esLocale            : BsLocaleService,
    public _filtro              : FiltrosService,
    private _datatable          : DatatablesService,
  ){

    this.getPermisos();
  }// .constructor

  ngOnInit()
  {
    let self = this;
    // this.datosfiltrosGenerales();

    //validar usuario ingresado
    let opcionEnviar = 'Ingreso Agendamiento';
    this._rastreo.setRastreo(opcionEnviar, 'Agendamiento').subscribe((resp)=>{
    });
    this._usuarios.getUserIngresado();

    //Bloque que permite controlar los clics para llos modal de las horas
    document.addEventListener("click", function(e) {
        var  hoursini, minutesini, secondsini;
        var datehoraini = new Date($('#horainicial').val());
        hoursini = ("0" + datehoraini.getHours()).slice(-2);
        minutesini = ("0" + datehoraini.getMinutes()).slice(-2);
        secondsini = ("0" + datehoraini.getSeconds()).slice(-2);
        var fulltimeini = [hoursini, minutesini, secondsini].join(":");

        var  hoursfin, minutesfin, secondsfin;
        var datehorafin = new Date($('#horafinal').val());
        hoursfin = ("0" + datehorafin.getHours()).slice(-2);
        minutesfin = ("0" + datehorafin.getMinutes()).slice(-2);
        secondsfin = ("0" + datehorafin.getSeconds()).slice(-2);
        var fulltimefin = [hoursfin, minutesfin, secondsfin].join(":");
        var display = $('#divhorainicial').css('display');

        if ( fulltimeini != 'aN:aN:aN' ) {

          $('#horainicial_0').val(fulltimeini);
        }
        if ( fulltimefin != 'aN:aN:aN' ) {
          $('#horafinal').val(fulltimefin);
        }
    }, false);

    //this.esLocale.use('es');

    //Escucha los eventos al presionar la tecla Enter
    this._evtjq.eventoTeclaEnter();

    let paramModAgendamiento = this.route.snapshot.paramMap.get('id');

    //Si llega el parametro oculta las opciones del modal
    if(paramModAgendamiento){
        this.mostraropcionModal = false;
    }
    //De lo contrario los muestra
    else{
        this.mostraropcionModal = true;
    }


    this.mostrarcalendar = false;
    //Si llega parametro
    this.identificadorAgenda = this.pqrid;// this.route.snapshot.paramMap.get('id');

    //Si el identificador es null
    if (this.identificadorAgenda == 'null' || this.identificadorAgenda == null) {
        this.mostrarBotonCrearAgenda = true;
        this.getPermisos();
    }
    //De lo contrario
    else {
        this.mostrarBotonCrearAgenda = false;
        this.getFiltroAgendamiento(this.identificadorAgenda);
        this.getPermisos();
    }

    this.filtrosformulario();
    this.obtenerTipoprioridad();
    this.obtenerTerceros('C');
    this.obtenerTecnicos();
    this.obtenerTerceros('P');
    this.obtenerCoordinadores();
    this.obtenerTipoPqr();
    this.obtenerEstadopqr();
    this.paramCampos();
    this.actionForm();

    //evento de los campos operaciones de la tabla equipo en el modulo de crear
    $(document).off('change', '.idchange').on('change', '.idchange', function(){
        var data_operacion = $(this).val().split('=>')[0];
        $(this).attr('data-operacion', data_operacion);
    });

    if(this.idperfil =="C" || this.idperfil =="S"){
        this.usuarioCliente = 1;
    }else{
        this.usuarioCliente = 0;
    }

    // permite al sistema cabiar de lor los texarea en las notas
    $(document).off('click','#privado').on('click','#privado',function(){
        if(!$(this).is(':checked')){
            $('#nota').css('background', 'white');
        }else{
            $('#nota').css('background', 'antiquewhite');
        }
    });

    // $('.btnFiltro').off('click', ).on('click', function(e){
    //     e.preventDefault();
    //     if($(".clasbtnFiltro").hasClass('hide') == false){
    //         $(".clasbtnFiltro").addClass('hide');
    //     }else{
    //         $(".clasbtnFiltro").removeClass('hide');
    //         $('.chosen-select').val('').trigger('chosen:updated');
    //     }
    // });

    // $('.chos-unit select[multiple]').chosen({
    //     placeholder_text_single: 'Seleccione Opción'
    //     ,width: '100%'
    //     ,no_results_text: 'Ooops, no se encuentra'
    // });

    // $('.chos-unit select[unitario]').chosen({
    //   placeholder_text_single: 'Seleccione Opción'
    //   ,width: '100%'
    //   ,no_results_text: 'Ooops, no se encuentra'
    // });


    $(document).off('change', '.costo').on('change', '.costo', function(){
      let fecha = self.nuevaprogramacion.fecha;
      let index = $(this).attr('data-index');

      let saldoconsumo = 0;
      let date = new Date(fecha);
      let anio = date.getFullYear();
        self._tratamientopqr.validarcostoProveedor($(this).attr('data-tecnicoid'),anio,self.nuevaprogramacion.pqrid).subscribe((resp)=>{
          if(resp.data.length > 0){
            var saldo     = resp.data[0].costoestimado - resp.data[0].consumo;
            var saldo_aux = saldo;
            if(saldo > 0){
                saldo = saldo - parseInt($(this).val()) ;
            }else{
                saldo     = 0;
                saldo_aux = 0;
            }

            if(saldo < 0){
              $(this).val('');
              saldoconsumo = resp.data[0].consumo ? resp.data[0].costoestimado - parseInt(resp.data[0].consumo):0;
              if($(this).attr('data-tipo') =='antes'){
                $('#alertaantes_'+index).removeClass('hide');
                $('#alertaantes_'+index).html('Supera el costo Permitido:<br> Saldo Actual :'+saldo_aux +'');
              }else{
                $('#alertanuevo_'+index).html('Supera el costo Permitido:<br> Saldo Actual :'+saldo_aux +'');
                $('#alertanuevo_'+index).removeClass('hide');
              }
            }else{
              self.noResultcosto = false;
              if($(this).attr('data-tipo') =='antes'){
                $('#alertaantes_'+index).addClass('hide');
                $('#alertaantes_'+index).html('');
              }else{
                $('#alertanuevo_'+index).addClass('hide');
                $('#alertanuevo_'+index).html('');
              }
            }
          }else{
            $(this).val('');
            saldoconsumo = 0;
          }
        });
    });

    // $(document).off('click', '.btnAdministrarFiltro').on('click', '.btnAdministrarFiltro', function(){
    //   if($("#dttableFiltro").is('.hide')){
    //     $("#dttableFiltro").removeClass('hide');
    //     $(".MFiltro").addClass('hide');
    //     self.Filtros = 'Administrar Filtros'
    //     self.dTFiltros.ajax.reload();
    //   }else{
    //     self.obtenerFiltro(null,'1');
    //     self.Filtros = 'Filtros'
    //     $(".MFiltro").removeClass('hide');
    //     $("#dttableFiltro").addClass('hide');
    //   }
    // });

    // $('#selectFiltro').off('change').on('change', function(e){
    //   e.preventDefault();
    //   self.obtenerFiltro($(this).val(),null);
    // });
    // this.submitfiltros(null);
  }// .ngOnInit()

  // obtenerFiltro(headfiltroid,filtrodefault){
    // let self = this;
    // this._filtro.obtenerFiltro(headfiltroid,filtrodefault, this.modulo,null);
    // // this._pqr.datosfiltrosGenerales().subscribe((resp)=>{
    // setTimeout(function(){
    //   self.submitfiltros();
    // },1000);

    // });
//  }

  obtenerContactoTercero(terceroid,sucursalid,valida){
    let self = this;
    this._contacto.obtenerContactoTercero(terceroid,sucursalid).subscribe((resp)=>{
      for (let i = 0; i < resp.data.length; i++) {
        let cargo           = resp.data[i].cargo ? ' Cargo - ' + resp.data[i].nombre : '';
        let profesion       = resp.data[i].nombreprofesion ? ' Profesión - ' + resp.data[i].nombreprofesion : '';
        let telefono        = resp.data[i].telefono ? ' Telefono - ' + resp.data[i].telefono : '';
        let dependencia     = resp.data[i].dependencia ? ' Dependencia - ' + resp.data[i].dependencia : '';
        resp.data[i].nombre = resp.data[i].nombre + cargo + profesion + telefono + dependencia;
      }
      this.contactos = resp.data;

      setTimeout(function(){
        if(self.accion == 'Crear'){
          $('.contactoid').val('').trigger('chosen:updated').attr('disabled',false);
        }else{
          if(valida == 1){
            $('.contactoid').val('').trigger('chosen:updated').attr('disabled',false);
            $('.contactoid').val('').trigger('chosen:updated').attr('disabled',false);
          }else{
            $('.contactoid').val(self.nuevaprogramacion.contactoid).trigger('chosen:updated').attr('disabled',true);
            $('.contactoid').val(self.nuevaprogramacion.contactoid).trigger('chosen:updated').attr('disabled',true);
          }
        }
      },1000);
    });
  }// .obtenerContacto(sucursalid)

  cargarDatatable(){
    let self = this;
    let $dt = $('#tblInsumopqr');
    this.dtTblInsumos =$dt.DataTable({
      language: self.language,
      dom: 'domBftrlp',
      processing: true,
      pageLength: 10,
      columnDefs: [
        {
          targets 	: [0],
          className : 'text-center',
          orderable : false,
        },
        {
          targets 	: [1,5,6],
          width 		: '1%',
          className 	: 'text-center',
        },
      ],
      buttons: self.buttons,
      createdRow: function(row, data, index){
        if(data[6] > 0){
          $(row).find('td:eq(0) .btnEliminar').removeClass("hide");
        }

        $(row).on("click", ".btnEliminar", function(e){
            e.preventDefault();
            swal({
                title: 'Esta Seguro de retirar la cantidad final?',
                text: "",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No'
            }).then((result) => {
              if (result.value)
              {
                let datos = {
                  headpqrinsumoid : $(row).find('td:eq(0) .btnEditarHE ').val()
                }
                self._tratamientopqr.eliminarRegInsumo(datos).subscribe((resp)=>{
                    if (resp.error) {
                      self.toastr.error('Ocurrio un Erorr', 'Error', { timeOut: 3000 });
                    }else{
                      data[7] = '';
                      data[6] = '';
                      self.toastr.success('Cantidad final eliminada con éxito', '', { timeOut: 3000 });
                      $(row).find('td:eq(0) .btnActualizarHE').val('');
                      $(row).find('td:eq(0) .btnEliminar').val('').addClass("hide");
                      $(row).find('td:eq(6)').html('');
                    }
                });
              }// .if / .else
            });
        });

        $(row).on("click", ".btnCancelarEdicionHEC", function(e){
            e.preventDefault();
            $(row).find('td:eq(6)').html(data[6]);
            $(row).find('td:eq(0) .btnActualizarHE span').removeClass("glyphicon-floppy-disk").addClass("glyphicon-pencil");
            $(row).find('td:eq(0) .btn-primary').removeClass("btnActualizarHE").addClass("btnEditarHE");
            $(row).find('td:eq(0) .btnEditarHE').removeClass("btn-primary").addClass("btn-success");
            $(row).find('td:eq(0) .btnCancelarEdicionHEC').addClass("hide");
            if(data[6] > 0){
              $(row).find('td:eq(0) .btnEliminar').removeClass("hide");
            }
        });

        $(row).on("click", ".btnEditarHE", function(e){
            e.preventDefault();
            let input = '<div class="chos-unit" style="background: #fff; padding-left: 0px;">';
                input += '<input type="number" class="form-control input_form"></div>';

            $(row).find('td:eq(6)').html(input);
            $(row).find('td:eq(6) input').val(data[6]);
            $(row).find('td:eq(0) .btnEditarHE span').removeClass("glyphicon-pencil").addClass("glyphicon-floppy-disk");
            $(row).find('td:eq(0) .btnEditarHE').removeClass("btn-success").addClass("btn-primary");
            $(row).find('td:eq(0) .btn-primary').removeClass("btnEditarHE").addClass("btnActualizarHE");
            $(row).find('td:eq(0) .btn-primary').attr('title', "Actualizar");
            $(row).find('td:eq(0) .btnCancelarEdicionHEC').removeClass("hide");
            $(row).find('td:eq(0) .btnEliminar').addClass("hide");
            $(row).find('td:eq(0) .btnCancelarEdicionHEC').attr('title', "Cancelar edición");
        });

        $(row).off("click",".btnActualizarHE").on("click",".btnActualizarHE", function(e){
            e.preventDefault();
            var cantfin = $(row).find('td:eq(6) input').val();
            if(parseInt(cantfin) > 0){
                var headpqrinsumoid = $(row).find('td:eq(0) .btnActualizarHE').val();

                data[6] = cantfin;
                let datos = {
                  headpqrinsumoid : headpqrinsumoid != 'null' ? headpqrinsumoid :null,
                  cantfin    : parseInt(cantfin),
                  cantini    : data[5],
                  productoid : data[2],
                  pqrid      : self.nuevaprogramacion.pqrid
                }
                self._tratamientopqr.InsertUpdateInsumo(datos).subscribe((resp)=>{
                    if (resp.error) {
                      self.toastr.error('Ocurrio un Erorr', 'Error', { timeOut: 3000 });
                    }else{
                      data[7] = resp.data;
                      self.toastr.success('Registro Almacenado con éxito', '', { timeOut: 3000 });
                      $(row).find('td:eq(0) .btnActualizarHE').val(resp.data);
                      $(row).find('td:eq(0) .btnEliminar').val(resp.data);
                      $(row).find('td:eq(6)').html(cantfin);
                      $(row).find('td:eq(0) .btnActualizarHE span').removeClass("glyphicon-floppy-disk").addClass("glyphicon-pencil");
                      $(row).find('td:eq(0) .btn-primary').removeClass("btnActualizarHE").addClass("btnEditarHE");
                      $(row).find('td:eq(0) .btnEditarHE').removeClass("btn-primary").addClass("btn-success");
                      $(row).find('td:eq(0) .btnCancelarEdicionHEC').addClass("hide");
                      $(row).find('td:eq(0) .btnEliminar').removeClass("hide");
                    }
                });
            }else{
                self.toastr.error('La cantidad final debe ser igual o superir a uno (1)', 'Error', { timeOut: 3000 });
                return;
            }
        });
      },
    });
    $("[id=tblInsumopqr] thead").addClass("thTDocs");
    $("[id=tblInsumopqr]").DataTable();
    $("[id=tblInsumopqr] tbody").addClass("tdTDocs");

    this.dtTblrelacionheadpqr = $('#relacionheadpqr').DataTable({
      language: self.language,
      dom: '',
      lengthChange :false,
      searchig:false,
      processing: true,
      pageLength: 10,
      order:[1,'asc'],
      columnDefs: [
        {
          targets 	: [0,1,],
          className : 'text-center',
          width 		: '1%',
          orderable : false,
        },
        {
          targets 	: [2],
          width 		: '10%',
        },
        {
          targets 	: [3,4],
          width 		: '20%',
        },
        {
          targets 	: [5],
          width 		: '70%',
        },
      ],
      buttons: self.buttons,
      createdRow: function(row, data, index){
        $(row).find('td:eq(2)').css('background',data[6]);
        $(row).find('td:eq(1)').html('<a class="dirigetratamiento" tooltip="ir Tratamiento de la incidencia">'+data[1]+'</a>');

        $(row).find('.dirigetratamiento').on("click", function(e){
          e.preventDefault();
              self.dirigetratamiento(data[1]);
        });

        $(row).find('.eliminarasignacion').on("click", function(e){
          e.preventDefault();
              self.eliminarasignacion(data[7],data[1]);
        });

      },
    });
    $("[id=relacionheadpqr] thead").addClass("thTDocs");
    $("[id=relacionheadpqr] tbody").addClass("tdTDocs");
  }

  relacionarInc(){
    this.arrayAsignacion = $('.pqrarelacionar').val();
    if(this.arrayAsignacion.length > 0){
      let data = {
        pqrid    : this.nuevaprogramacion.pqrid,
        arraypqr : this.arrayAsignacion
      }
      this._tratamientopqr.submitRelacionarInc(data).subscribe((resp)=>{
        if (resp.error) {
          this.toastr.warning(resp.message, 'Alerta', { timeOut: 3000 });
          this.disabled= false;
        } else {
          this.toastr.success(resp.message, '', { timeOut: 3000 });
          $('.pqrarelacionar').val('').trigger('chosen:updated');
          this.getIncAsignada();
        }
      });
    }else{
      this.toastr.warning('No hay datos para guardar', 'Alerta', { timeOut: 3000 });
    }
  }

  dirigetratamiento(pqrid){
    swal({
          title: 'Esta seguro de ir al Tratamiento de la incidencia?',
          text: "",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar'
    }).then((result) => {
          if (result.value) {
            this.router.navigate(['main/enrutamientos/enrutamientopqr/'+pqrid], { replaceUrl: true });
          }
    });
   }

   eliminarasignacion(id,pqrid){
    swal({
          title: 'Esta seguro de retirar la relación de la incidencia: '+pqrid+' ?',
          text: "",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar'
    }).then((result) => {
        this._tratamientopqr.eliminarasignacion(id).subscribe((resp)=>{
            if (resp.error) {
              this.toastr.error('Ocurrio un Erorr', 'Error', { timeOut: 3000 });
            }else{
              this.toastr.success('Registro eliminado con éxito', '', { timeOut: 3000 });
              let opcionEnvio = 'Elimina Relacion incidencia: '+ pqrid + ' de la incidencia: '+  this.nuevaprogramacion.pqrid;
              this._rastreo.setRastreo(opcionEnvio, 'Tratamiento Incidencia , relación Incidencia').subscribe((resp)=>{
              }); // fin rastreo
              this.getIncAsignada();
            }
        });
    });
   }

   getIncAsignada(){
    let filas = [];
    this._tratamientopqr.getIncAsignada(this.nuevaprogramacion.pqrid).subscribe((resp)=>{
      $.each(resp.data, function(){
        let btn = '';
          btn    = "<button type='button' value='"+this.relacionheadpqrid+"' class=' btn btn-danger btn-xs eliminarasignacion' title='Eliminar'><span class='glyphicon glyphicon-remove'></span></button>";
          var fila = {
            0:btn,
            1:this.pqridrelacionada,
            2:this.nombreestadopqr,
            3:this.equipo,
            4:this.nombre,
            5:this.asunto,
            6:this.colorhexadecimal,
            7:this.relacionheadpqrid
          };
          filas.push(fila);
      });
      this.dtTblrelacionheadpqr.clear().draw();
      this.dtTblrelacionheadpqr.rows.add(filas).draw();
    });
  }

  setHeadpqrInsumos(operacionid){
    let self = this;
    let filas = [];
    let data  = {
      pqrid       : this.nuevaprogramacion.pqrid,
      operacionid : operacionid
    }
    this._tratamientopqr.setHeadpqrInsumos(data).subscribe((resp)=>{
      $.each(resp.data, function(){
        let btn = '';
        let btnEli = '';
          btn    = "<button type='button' value='"+this.headpqrinsumoid+"' class='btnEditarHE btn btn-success btn-xs' title='Editar' style='margin-right:5px'><span class='glyphicon glyphicon-pencil'></span></button><button type='button' value='"+this.headpqrinsumoid+"' class='hide btn btn-danger btn-xs btnCancelarEdicionHEC' title='Eliminar'><span class='glyphicon glyphicon-remove'></span></button>";
          btnEli = "<button type='button' value='"+this.headpqrinsumoid+"' class='hide btn btn-danger btn-xs btnEliminar' title='Eliminar Cantidad'><span class='glyphicon glyphicon-remove'></span></button>";

          var fila = {
            // 0:btn + btnEli,
            0:btn,
            1:this.tipo,
            2:this.productoid,
            3:this.producto,
            4:this.operacion,
            5:this.cantini,
            6:this.cantfin,
            7:this.headpqrinsumoid
          };
          filas.push(fila);
      });
      this.dtTblInsumos.clear().draw();
      this.dtTblInsumos.rows.add(filas).draw();


      if(this.disabledcampo == true){
          $('.btnEditarHE').attr('disabled',true);
          $('.btnEliminar').attr('disabled',true);
      }
    });
  }

  datosfiltrosGenerales(){
    setTimeout(function(){
      let opcionEnviar = 'Ingreso Agendamiento';
      this._rastreo.setRastreo(opcionEnviar, 'Agendamiento').subscribe((resp)=>{
      });
      this._usuarios.getUserIngresado();
      // this.getAgendamientoFiltros();
    },3000);
    this.obtenerTipoServicio();
    this.submitfiltros(null);
    this._pqr.datosfiltrosGenerales().subscribe((resp)=>{
      if (resp.data) {
        this.statesClienteFiltros        = resp.data.tercero;
        this.statesNombrComerFiltros     = resp.data.nombrcomer;
        this.statesSucursalFiltros       = resp.data.sucursal;
        this.statesFamiliaFiltros        = resp.data.familia;
        this.statesEquipoFiltroMultiples = resp.data.equipo;
        this.statesMarcaFiltros          = resp.data.marca;
        this.statesAdquisicionFiltro     = resp.data.tipoadquisicion;
        this.statesEstadoFiltros         = resp.data.estadopqr;
        this.statesTipoServicioFiltros   = resp.data.tiposerviciopqr;
        this.statesPrioridadFiltros      = resp.data.prioridad;
        this.statesTecnicoFiltros        = resp.data.tecnico;
        this.statescodigointernoFiltro   = resp.data.codigointerno;
        this.statesPqr                   = resp.data.pqr;
        this.statesTicket                = resp.data.ticket;
      }
      let self = this;

      setTimeout(function(){
        let opcionEnviar = 'Ingreso Agendamiento';
        self._rastreo.setRastreo(opcionEnviar, 'Agendamiento').subscribe((resp)=>{
        });
        self._usuarios.getUserIngresado();
        // self.getAgendamientoFiltros();
      },3000);
      this.obtenerTipoServicio();

      // this._filtro.obtenerFiltroAgenda(null,'1',this.modulo).subscribe((resp)=>{
      //   this.mostrarpreloaderpri = false;
      //   $('.chosen-select').val('').trigger('chosen:updated');
      //   let totalFiltros = resp.data[0];
      //   let dataFiltro   = resp.data[1];
      //   let option =  '';
      //   for (let j = 0; j < totalFiltros.length; j++) {
      //     option += '<option value="'+totalFiltros[j].headfiltroid+'">'+totalFiltros[j].nombre+'<option>'
      //   }
      //   for (let j = 0; j < dataFiltro.length; j++) {
      //     if($('[data-modulo='+dataFiltro[j].campo+']').is("[multiple]")){
      //         $('[data-modulo='+dataFiltro[j].campo+']').val(dataFiltro[j].valor.split(',')).trigger('chosen:updated');
      //     }else{
      //         $('[data-modulo='+dataFiltro[j].campo+']').val(dataFiltro[j].valor).trigger('chosen:updated');
      //     }
      //   }
      //   $('#selectFiltro').html(option);
      //   if(dataFiltro.length > 0){
      //       $('#selectFiltro_chosen').removeClass('hide');
      //       $('.nombre').addClass('hide');
      //       $('#headfiltroid').val('');
      //       $('#nombre').val('');
      //       $('#selectFiltro').val(dataFiltro[0].headfiltroid).trigger('chosen:updated');
      //   }
      //   self.submitfiltros();
      // });
    });
  }

  createForm(){
      if(this.nuevaprogramacion.esproveedor != '1'){
          this.obtenerCoordinadores();
          this.TecnicoList = [];
          this.arrayAgregarTecnicos = [];
      }else{
          this.obtenerTerceros('P');
      }
  }

  /**
   * Permite cerrar un modal
   * CAAA-2019-01-16
   */
  cerrarmodal(){
      $('.modal:visible:last, .modal-backdrop').fadeOut();
      $('.modal:visible:last').remove();
      if($('.modal:visible').length <= 0){
          $('body').removeClass('modal-open');
      }
  }// .cerrarmodal()

  /**
   * Permite adicionar campos dinamicos en el formulario
   * JMM-2018-07-18
   */
  adicionarCampos(){
      var newItemNo;
      newItemNo = this.campos.length+4;
      this.campos.push( {'id': 'campo1'+newItemNo} );
      this.cantidadcampos = '' + this.campos.length;
      this.activarAdicionarCampos = false;
  }// .adicionarCampos()

 /**
   * Permite adicionar a una lista los técnicos que se van a asignar
   * CESAR ARIAS-2019-08-28
   */
  agregarTecnicos(param,nombretecnico){
    if (param == 1)
    {
      let idtercero = '';
      let tipotercero = ''
      let nombretercero = '';
      if(this.nuevaprogramacion.esproveedor != 1){
          idtercero     = $('#tecnicoid').val() ? $('#tecnicoid').val().split("-") : '';
          idtercero     = idtercero[0] ? idtercero[0].trim() : '';
          nombretercero = $('#tecnicoid').find('option:selected').text();
          tipotercero   = 'Técnicos';
      }else{
          idtercero     = $('#proveedor').val() ? $('#proveedor').val() : '';
          tipotercero   = 'Proveedores';
          nombretercero = $('#proveedor').find('option:selected').text();
      }

      for (let i=0; i<=$('#cantidadcampos').val()-1; i++){
        //Se realiza un split para sacar los identificadores:
        if ( idtercero != '' && idtercero != undefined ) {
          // valida que el tecnico seleccionado no se encuentre en la tabla de tecnicos antes asignados
          let comparador = 0;
          if (this.TecnicoList) {
              for (let j=0; j<=this.TecnicoList.length-1; j++) {
                  if (this.TecnicoList[j]['tecnicoid'] ==  idtercero) {
                    comparador = comparador + 1;
                  }
              }
          }

          let comparador2 = 0;
          for (let j=0; j<=this.arrayAgregarTecnicos.length-1; j++) {
            let aux  = this.arrayAgregarTecnicos[j].tecnicoid;
              if (aux.replace(/ /g,"").split("-")[0] ==  idtercero) {
                 comparador2 = comparador2 + 1;
              }
          }

          if(comparador2 > 0 || comparador > 0){
          }
          //Valida si existe un tecnico asignado
          if ( (idtercero != undefined) && (comparador2 > 0) && (comparador == 0) ) {
             this.toastr.error('Ya existe un '+tipotercero+' con el mismo número de identificación en la lista de nuevos '+tipotercero+' asignar!' , '', { timeOut: 3000 });
          }
          //De lo contrario lo asigna
          else if(comparador == 0){
              let dataTecnico = {
                'nombre'         : nombretercero,
                'tecnicoid'      : idtercero,
                'TecnicoList' : ''
              }

              this.arrayAgregarTecnicos.push(dataTecnico);
          }else{
             this.toastr.error('El '+tipotercero+' seleccionado ya se encuentra en la lista de '+tipotercero+' antes asignados!' , '', { timeOut: 3000 });
          }
        }
      }// .for
    }// .if
    else if (param == 2) {
      for (let i=0; i<=$('#cantidadcampos').val()-1; i++){
         //Se realiza un split para sacar los identificadores:
         let tecnicoid_aux = $('#otrotecnicoid').val() ? $('#otrotecnicoid').val().split("-") : '';
         let tecnicoid = tecnicoid_aux[0] ? tecnicoid_aux[0].trim() : '';

        if ( $('#otrotecnicoid').val() != '' && $('#otrotecnicoid').val() != undefined ) {
          // valida que el tecnico seleccionado no se encuentre en la tabla de tecnicos antes asignados
          let comparador = 0;
          if (this.TecnicoList) {
            for (let j=0; j<=this.TecnicoList.length-1; j++) {
                if (this.TecnicoList[j]['tecnicoid'] ==  tecnicoid) {
                  comparador = comparador + 1;
                }
            }
          }

          //Valida si existe un tecnico asignado
          if ( ($('#otrotecnicoid').val() != undefined) && (this.arrayAgregarTecnicos.includes($('#otrotecnicoid').val())) && (comparador == 0) ) {
              this.toastr.error('Ya existe un técnico con el mismo número de identificación en la lista de nuevos técnicos asignar!' , '', { timeOut: 3000 });
          }
          //De lo contrario lo asigna
          else if(comparador == 0){
              this.arrayAgregarTecnicos.push($('#otrotecnicoid').val());
          }else{
              this.toastr.error('El técnico seleccionado ya se encuentra en la lista de técnicos antes asignados!' , '', { timeOut: 3000 });
          }
        }
      }// .for
    }else{

        let tecnicoid_aux   = nombretecnico ? nombretecnico.split("-") : '';
        let tecnicoid       = tecnicoid_aux[0] ? tecnicoid_aux[0].trim() : '';
        let nombretecnicoid = tecnicoid_aux[1] ? tecnicoid_aux[1].trim() : '';
        let comparador = 0;

        if (this.TecnicoList) {
          for (let j=0; j<=this.TecnicoList.length-1; j++) {
              if (this.TecnicoList[j]['tecnicoid'] == tecnicoid) {
                comparador = comparador + 1;
              }
          }
        }

        //Valida si existe un tecnico asignado
        if ( (nombretecnico != undefined) && (comparador != 0) ) {
            return;
        }else if(comparador == 0){
          let validar = this.arrayAgregarTecnicos.filter(function(car){
              return car.tecnicoid == tecnicoid;
          });
          if(validar.length == 0){
            let dataTecnico = {
              'nombre'         : nombretecnicoid,
              'tecnicoid'      : tecnicoid,
              'TecnicoList'    : ''
            }
            this.arrayAgregarTecnicos.push(dataTecnico);
          }
        }
    }
  }// .agregarTecnicos()

  /**
   * Permite eiliminar un elemento de listado de tecnicos que se van a asignar por medio de un indice
   * CESAR ARIAS -2019-08-28
   */
  quitarTecnicoDeListado(i){
      this.arrayAgregarTecnicos.splice(i, 1);
  }

  /**
   * Permite validar el formulario
   * JMM-2018-06-19
   */
  actionForm(){
    this.formBusqueda = new FormGroup({
      'incidenciaid'      : new FormControl(''),
      'tecnicoid'         : new FormControl(''),
      'clienteid'         : new FormControl(''),
      'sucursalid'        : new FormControl(''),
      'serial'            : new FormControl(''),
      'familiaid'         : new FormControl(''),
      'marcaid'           : new FormControl(''),
      'tipoadquisicionid' : new FormControl(''),
      'codigointerno'     : new FormControl(''),
      'ticket'            : new FormControl(''),
      'estadoid'          : new FormControl(''),
      'servicioid'        : new FormControl(''),
      'prioridadid'       : new FormControl(''),
      'fechacreacion'     : new FormControl(''),
      'fechacierre'       : new FormControl(''),
      'fechaIniLimite'    : new FormControl(''),
      'fechaFinLimite'    : new FormControl(''),
      'nombrcomer'        : new FormControl(''),
      'tipoincfiltro'     : new FormControl('0'),
    });
  }

  /**
   * Envia la peticion a un servicio para hacer un filtro
   * JMM-2018-06-21
   */
    submitfiltros(data){
 

    if (data != null){
      this.formBusqueda.reset();
      this.formBusqueda.patchValue(data.formFiltros);
    }
    console.log(this.formBusqueda.value);
    this.mostrarcalendar = false;
    let dataAgenda = new Array();
    this.mostrarpreloader = true;
    this.data = [];

    this.formBusqueda.value.especiales_verCliente_Sucursal_por_usuario = this.listpermisos.especiales_verCliente_Sucursal_por_usuario;
    this._agendamiento.obtenerFiltroAgendamientoApp(this.formBusqueda.value).subscribe((res)=>{
      dataAgenda = res.data;
      if(dataAgenda){
        this.mostrarpreloaderpri = false;
        this.mostrarpreloader = false;
        this.mostrarcalendar = true;

            //Preparación de los datos para enviarlos al calendario
          for(let i in dataAgenda){
            if(dataAgenda[i].estado_actualizado == 1){
                let fechafinal;

              //Validación para aumentar un dia y que se pueda visualizar bien el evento en la agenda
              if(dataAgenda[i].fechafinal){
                  let array_fechafinal = dataAgenda[i].fechafinal.split("-");
                  let anio = parseInt(array_fechafinal[0]);
                  let mes = parseInt(array_fechafinal[1]).toString();
                  let dia_aux1 = parseInt(array_fechafinal[2]);
                  let dia_aux2 = dia_aux1 + 1;
                  let dia = dia_aux2.toString();
                  fechafinal = anio + '-' + (mes.length == 1 ? '0'+mes : mes) + '-' + (dia.length == 1 ? '0'+dia : dia);
              }// .if

              let dataTecnico = (dataAgenda[i].tecnicoid != '' && dataAgenda[i].tecnicoid != 'null' && dataAgenda[i].tecnicoid != null) ? dataAgenda[i].tecnicoid + ' - ' + dataAgenda[i].nombretecnico : '';

              //Arreglo para enviar los datos que se visualizan en el calendario
              let TipoEncargado = 'Técnico:     ';
              if(dataAgenda[i].esproveedor ==1){
                TipoEncargado = 'Proveedor:     '
              }

              let  nombrecliente     = dataAgenda[i].nombrecliente     ? dataAgenda[i].nombrecliente :'';
              let  nombresucursal    = dataAgenda[i].nombresucursal    ? dataAgenda[i].nombresucursal :'';
              let  nombreadquisicion = dataAgenda[i].nombreadquisicion ? dataAgenda[i].nombreadquisicion :'';
              let  codigointerno     = dataAgenda[i].codigointerno     ? dataAgenda[i].codigointerno :'';
              let  operacion         = dataAgenda[i].operacion         ? dataAgenda[i].operacion :'';
              let  nombrcomer        = dataAgenda[i].nombrcomer        ? dataAgenda[i].nombrcomer :'';

              this.data.push({
                pqrid           : dataAgenda[i].pqrid,
                agendamientoid  : dataAgenda[i].agendamientoid,
                title           : '   Cliente:        ' + nombrecliente +
                                  ' \nSucursal:       ' + nombresucursal  +
                                  ' \nN.Comercial:'     + nombrcomer  +
                                  ' \nINC:            ' + dataAgenda[i].pqrid +
                                  ' \nCódigo Interno: ' + codigointerno  +
                                  ' \nAdquisición:    ' + nombreadquisicion  +
                                  ' \nOperación:      ' + operacion  +
                                  ' \n'+TipoEncargado + dataTecnico +
                                  ' \nHora Inicio: ' + dataAgenda[i].horainicial + ' - Hora Fin: ' + dataAgenda[i].horafinal+
                                  ' \nVisibilidad:      ' +  dataAgenda[i].visibilidad,

                start           : dataAgenda[i].fecha,
                end             : dataAgenda[i].fechafinal,
                backgroundColor : dataAgenda[i].colorhexadecimal,
                borderColor     : (dataAgenda[i].visibilidad == 'Privado' ? '#64d07f' : dataAgenda[i].colorhexadecimal)
              });
            }
          }// .for

            //Enviar los datos al calendario
          this.calendarOptions = {
              selectable: true,
              editable : true,
              eventLimit : false,
              header : {
                left   : 'prev,next, today',
                center : 'title',
                right  : 'listYear,month, agendaWeek, agendaDay'
              },
              locale:'es',
              events : this.data
          };

        let tecnicosArray = new Array();

        for(let i = 0; i < res.data.length; i++){
            tecnicosArray.push(res.data[i]);
        }
        this.tecnicoArray = tecnicosArray;
      }else{
        this.mostrarpreloader = true;
      }
    });
  }// .submitfiltros()

  /**
   * Limpia todo los filtros
   * JMM-2018-06-21
   */
  borrarfiltros($data){
      this.formBusqueda.reset();
      $('.chosen-select').val('').trigger('chosen:updated');
      $('[data-modulo=fechainicialFiltro]').val('');
      $('[data-modulo=fechafinalFiltro]').val('');
      $('[data-modulo=fechaIniLimiteFiltro]').val('');
      $('[data-modulo=fechaFinLimiteFiltro]').val('');
      if($data == 1){
        this.mostrarpreloader = true;
        this.data = [];
        this.submitfiltros(null);
      }
  }

  /**
   * Obtener parametros de la tabla montaje para viualizar campos
   * JMM-2018-10-04
   */
  paramCampos(){
    //Obtener parametros
    this._pqr.paramCampos().subscribe((resp)=>{
        if(resp.data){
          this.servicio                   = resp.data.servicio;
          this.agendaautomatica           = resp.data.agendaautomatica;
          this.estadofechainc             = resp.data.estadofechainc;
          this.estadoactividadincidencia  = resp.data.actividadincidencia;
          this.fichatecnica               = resp.data.fichatecnica;
          this.agendartodotiposervicio    = resp.data.agendartodotiposervicio;
          this.validaticket               = resp.data.validaticket;
          this.incconelineaconta          = resp.data.incconelineaconta;
          this.incconelineainven          = resp.data.incconelineainven;
          this.servidorbdconta            = resp.data.servidorbdconta;
          this.basedatosconta             = resp.data.basedatosconta;
          this.usuarioconta               = resp.data.usuarioconta;
          this.claveconta                 = resp.data.claveconta;
          this.servidorbdinven            = resp.data.servidorbdinven;
          this.basedatosinven             = resp.data.basedatosinven;
          this.usuarioinven               = resp.data.usuarioinven;
          this.claveinven                 = resp.data.claveinven;
          this.tipoinventario             = resp.data.tipoinventario;
          this.tercerocreacionincidencia  = resp.data.tercerocreacionincidencia;
          this.razonsocial                = resp.data.razonsocial;
          this.nombrcomer                 = resp.data.nombrcomer;
          this.estadoincidencia           = resp.data.estadoincidencia;
          this.nombretercero              = resp.data.nombretercero;
          this.primaestado                = resp.data.primaestado;
          this.estadopqridCliente         = resp.data.estadopqridcliente;
          this.procesorequisicion         = resp.data.procesorequisicion;

          this.hidecontacto               = this.servicio == '1' ? false : true;
          this.obtenerTipoServicio();
        }
    });
  }

  /**
   * Permite obtener los permisos y perfiles de usuario
   * JMM-2018-12-26
   */


   async getPermisos(){
    // this.obtenerFiltro(null,'1');
    await this._perfiles.getPermisosUsuariosFull().subscribe((resp)=>{
      if (resp.data) {
          // this.mostrarpreloaderpri = false;
          this.listpermisos = resp.data;
          this.mostrarFiltro = true;
      } else {
          // this.mostrarpreloaderpri = true;
      }

    });
  }

  /**
   * Permite abrir un modal para seleccionar la hora
   * JMM-2019-02-21
   */
  abrirModalHora(eventoclic, param,id){
    if (param == 'divhorainicial') {
      this.eventoclic = (eventoclic == 1) ? 0 : 1;
        if (this.eventoclic == 0) {
            $('#divhorainicial_'+id).show();
        } else {
            $('#divhorainicial_'+id).hide();
        }
    }
    if (param == 'divhorafinal') {
        this.eventoclic = (eventoclic == 1) ? 0 : 1;
        if (this.eventoclic == 0) {
            $('#divhorafinal_'+id).show();
        } else {
            $('#divhorafinal_'+id).hide();
        }
    }
  }

  // esto esta pendiente (sirve cuando se arrastra el evento)
  eventDrop(e) {
      console.log('mover: ', e);
  }

  public onEventLog(event: string, data: any): void {
      console.log(event, data);
  }

  /**
   * Permite cambiar el color
   * JMM-2018-07-12
   */
  public onChangeColorCmyk(color: string): Cmyk{
    const hsva = this.cpService.stringToHsva(color);
    if (hsva) {
        const rgba = this.cpService.hsvaToRgba(hsva);
        return this.cpService.rgbaToCmyk(rgba);
    }
    return new Cmyk(0, 0, 0, 0);
  }

  /**
   * Permite cambiar el color en hexadecimal
   * JMM-2018-07-12
   */
  public onChangeColorHex8(color: string): string{
      const hsva = this.cpService.stringToHsva(color, true);
      if (hsva) {
          return this.cpService.outputFormat(hsva, 'rgba', null);
      }
      return '';
  }

  /**
   * Función para obtener el listado del Agendamiento de la app
   * JMM-2018-11-14
   */
  getAgendamiento(){
    let dataAgenda = new Array();
    this.mostrarpreloader = true;
    this.data = [];
    this.statesTecnico = [];

    //envia el listado de permisoa para cargar las incidencias
    let listadopermisos = {
        'especiales_verCliente_Sucursal_por_usuario': this.listpermisos.especiales_verCliente_Sucursal_por_usuario,
        'permiso_vertodaslasincidencias' : this.listpermisos.especiales_vertodaslasincidencias,
        'especiales_vertodaslasincidencias_por_dependencia' : this.listpermisos.especiales_vertodaslasincidencias_por_dependencia,
        'especiales_vertodas_incidencias_reportadas_por_usuario' : this.listpermisos.especiales_vertodas_incidencias_reportadas_por_usuario,
        'usuario' : localStorage.getItem('usuarioid'),
        'cedulaUsuario' : localStorage.getItem('usuarioid'),
    }

    this._agendamiento.getRegistrosAgendaPermiso(listadopermisos).subscribe((res)=>{
        dataAgenda = res.data;
        if(dataAgenda){
          this.mostrarpreloader = false;
          this.mostrarcalendar = true;
          //Preparación de los datos para enviarlos al calendario
          for(let i in dataAgenda){
              if(dataAgenda[i].estado_actualizado == 1){
                let fechafinal;

                //Validación para aumentar un dia y que se pueda visualizar bien el evento en la agenda
                if(dataAgenda[i].fechafinal){
                  let array_fechafinal = dataAgenda[i].fechafinal.split("-");
                  let anio = parseInt(array_fechafinal[0]);
                  let mes = parseInt(array_fechafinal[1]).toString();
                  let dia_aux1 = parseInt(array_fechafinal[2]);
                  let dia_aux2 = dia_aux1 + 1;
                  let dia = dia_aux2.toString();
                  fechafinal = anio + '-' + (mes.length == 1 ? '0'+mes : mes) + '-' + (dia.length == 1 ? '0'+dia : dia);
                }// .if

                let dataTecnico = (dataAgenda[i].tecnicoid != '' && dataAgenda[i].tecnicoid != 'null' && dataAgenda[i].tecnicoid != null) ? dataAgenda[i].tecnicoid + ' - ' + dataAgenda[i].nombretecnico : '';

                //Arreglo para enviar los datos que se visualizan en el calendario
                let TipoEncargado = 'Técnico:     ';
                if(dataAgenda[i].esproveedor ==1){
                    TipoEncargado = 'Proveedor:     '
                }
                let  nombrecliente     = dataAgenda[i].nombrecliente     ? dataAgenda[i].nombrecliente     :'';
                let  nombresucursal    = dataAgenda[i].nombresucursal    ? dataAgenda[i].nombresucursal    :'';
                let  nombreadquisicion = dataAgenda[i].nombreadquisicion ? dataAgenda[i].nombreadquisicion :'';
                let  codigointerno     = dataAgenda[i].codigointerno     ? dataAgenda[i].codigointerno     :'';
                let  operacion         = dataAgenda[i].operacion         ? dataAgenda[i].operacion         :'';
                let  nombrcomer        = dataAgenda[i].nombrcomer        ? dataAgenda[i].nombrcomer        :'';

                this.data.push({
                  pqrid           : dataAgenda[i].pqrid,
                  agendamientoid  : dataAgenda[i].agendamientoid,
                  title           : '   Cliente:        ' + nombrecliente +
                                    ' \nSucursal:       ' + nombresucursal  +
                                    ' \nN.Comercial:'     + nombrcomer  +
                                    ' \nINC:            ' + dataAgenda[i].pqrid +
                                    ' \nCódigo Interno: ' + codigointerno  +
                                    ' \nAdquisición:    ' + nombreadquisicion  +
                                    ' \nOperación:      ' + operacion  +
                                    ' \n'+TipoEncargado + dataTecnico +
                                    ' \nHora Inicio: ' + dataAgenda[i].horainicial + ' - Hora Fin: ' + dataAgenda[i].horafinal+
                                    ' \nVisibilidad:      ' +  dataAgenda[i].visibilidad,

                  start           : dataAgenda[i].fecha,
                  end             : dataAgenda[i].fechafinal,
                  backgroundColor : dataAgenda[i].colorhexadecimal,
                  borderColor     : (dataAgenda[i].visibilidad == 'Privado' ? '#64d07f' : dataAgenda[i].colorhexadecimal)
                });
              }
          }// .for
          //Enviar los datos al calendario
          this.calendarOptions = {
              selectable: true,
              editable : true,
              eventLimit : false,
              header : {
                left : 'prev,next, today',
                center : 'title',
                right : 'listYear,month, agendaWeek, agendaDay'
              },
              locale:'es',
              events : this.data,
          };
          let tecnicosArray = new Array();
          for (let i = 0; i < res.data.length; i++) {
             tecnicosArray.push(res.data[i]);
          }
          this.tecnicoArray = tecnicosArray;
        }else {
            this.mostrarpreloader = true;
        }
    });
  }

  onSelectTecnico(event: TypeaheadMatch): void { this.selectedOptionTecnico = event.item.tecnicoid; }
  onSelectEquipoFiltro(event: TypeaheadMatch): void {
      let data = ($('#filtroEquipo').val().replace('<em>','').replace('</em>','')); // elimina etiquetas de la cadena de texto
      $('#filtroEquipo').val(data);
   }

  /**
   * Permite abril un modal para editar el agendamiento
   * JMM-2018-11-07
   */
  eventClick(e, template:any){
      this.validaversion = false;
      let self = this;
      this.mostrarBotonHabilitarModificar = false;
      this.arrayAgregarTecnicos = [];  //limpia campos de las tablas de los nuevos tecnicos
      this.TecnicoList = [];  //limpia campos de las tablas de los  tecnicos antes asignados
      this.nuevaprogramacion.cantidad_inc = '1';

      this.totalActividadesFamilia =[];
      this.totalActividades = [];

      this.accion = 'Consultar';
      this.disabledcampo = true;
      this.mostrarCampo = true;
      this.disabledBtnGuardar = true;
      this.formnuevaprogramacion();
      this.formNuevaprogramacion.reset();
      this.modalRef = this.modalService.show(template, {backdrop:'static', keyboard:false, class: 'gray modal-md modal_agendaiento'});
      $('.chos-unit select[unitario]').chosen({
          placeholder_text_single: 'Seleccione Opción'
          ,width: '100%'
        ,no_results_text: 'Ooops, no se encuentra'
      });

      $('.chos-unit select[multiple]').chosen({
          placeholder_text_single: 'Seleccione Opción'
          ,width: '100%'
          ,no_results_text: 'Ooops, no se encuentra'
      });

      $('.crearEditarPqr').off('change', ).on('change', function(e){
          e.preventDefault();

          self.onSelectEquipo($(this).val());
      });

      $('.creatEditSucursal').off('change', ).on('change', function(e){
          e.preventDefault();
          $('.crearEditarPqr').val('').trigger('chosen:updated').attr('disabled',true);
          $('.crearEditarPqr').val('').trigger('chosen:updated').attr('disabled',true);
          self.obtenerEquipos(null,1);
      });

      this.getRegAgendamiento(e.event.agendamientoid, e.event.pqrid);
  }// .eventClick(e, template:any)

  /**
   * Obtener un registro de Familias
   * JMM-2018-06-25
   */
  getRegAgendamiento(agendamientoid, pqrid){
      let dataactividad
      this.totalActividadesFamilia = [];
      $('.chos-unit select[unitario]').chosen({
           placeholder_text_single: 'Seleccione Opción'
          ,width: '100%'
          ,no_results_text: 'Ooops, no se encuentra'
      });

      this._agendamiento.getRegistroAgendamiento(agendamientoid, pqrid).subscribe((resp)=>{
        this.cargarDatatable();
        $("#contOperacion").removeClass("hidden");
        if (resp.data) {
            this.nuevaprogramacion.agendamientoid          = resp.data.agendamientoid;
            this.nuevaprogramacion.pqrarelacionar          = resp.data.pqrarelacionar;
            this.nuevaprogramacion.fechaagendaid           = resp.data.fechaagendaid;
            this.nuevaprogramacion.contactoid              = resp.data.contactoid;
            this.nuevaprogramacion.versionid               = resp.data.versionid;
            this.nuevaprogramacion.detallepqrid            = resp.data.detallepqrid;
            this.nuevaprogramacion.alertapqrid             = resp.data.alertapqrid;
            this.nuevaprogramacion.pqrid                   = resp.data.pqrid;
            this.nuevaprogramacion.ticket                  = resp.data.ticket;
            this.nuevaprogramacion.fecha                   = resp.data.fecha;
            this.nuevaprogramacion.horainicial             = resp.data.horainicial;
            this.nuevaprogramacion.horafinal               = resp.data.horafinal;
            this.nuevaprogramacion.estado                  = resp.data.estado;
            this.nuevaprogramacion.tipopqrid               = resp.data.tipopqrid;
            this.nuevaprogramacion.estadopqrid             = resp.data.estadopqrid;
            this.nuevaprogramacion.esproveedor             = resp.data.esproveedor;
            this.nuevaprogramacion.cierre                  = resp.data.cierre ? resp.data.cierre : '0';
            this.nuevaprogramacion.tiposervicioid          = resp.data.tiposervicioid;
            this.nuevaprogramacion.terceroid               = resp.data.clienteid + '=>' + resp.data.nombrecliente;
            this.nuevaprogramacion.sucursalid              = (resp.data.sucursalid != null && resp.data.sucursalid != undefined && resp.data.sucursalid != '') ? resp.data.sucursalid + '=>' + resp.data.nombresucursal : '';
            this.nuevaprogramacion.equipoterceroid         = resp.data.equipoterceroid + '=>' + resp.data.nombreequipo + (resp.data.serial ?  ' Serial->'+ resp.data.serial : '');
            this.nuevaprogramacion.coordinadorid           = resp.data.coordinadorid;
            this.nuevaprogramacion.presupuestoplaneado     = resp.data.presupuestoplaneado;
            this.nuevaprogramacion.presupuestoplaneado_aux = resp.data.presupuestoplaneado;
            this.nuevaprogramacion.asunto                  = resp.data.asunto;
            this.nuevaprogramacion.descripcion             = resp.data.descripcion ? resp.data.descripcion : '';
            this.nuevaprogramacion.fechafinal              = resp.data.fechafinal;
            this.nuevaprogramacion.prioridadid             = resp.data.prioridadid ? resp.data.prioridadid : '';
            this.nuevaprogramacion.colorhexadecimal        = resp.data.colorhexadecimal ? resp.data.colorhexadecimal : '';
            this.nuevaprogramacion.pqrid_aux               = resp.data.pqrid;
            this.nuevaprogramacion.fecha_aux               = resp.data.fecha;
            this.nuevaprogramacion.horainicial_aux         = resp.data.horainicial;
            this.nuevaprogramacion.horafinal_aux           = resp.data.horafinal;
            this.nuevaprogramacion.estado_aux              = resp.data.estado;
            this.nuevaprogramacion.tipopqrid_aux           = resp.data.tipopqrid;
            this.nuevaprogramacion.estadopqrid_aux         = resp.data.estadopqrid;
            this.nuevaprogramacion.esproveedor_aux         = resp.data.esproveedor;
            this.nuevaprogramacion.tiposervicioid_aux      = resp.data.tiposervicioid;
            this.nuevaprogramacion.terceroid_aux           = resp.data.clienteid;
            this.nuevaprogramacion.sucursalid_aux          = resp.data.sucursalid ?  resp.data.sucursalid + '-' + resp.data.nombresucursal : '';
            this.nuevaprogramacion.equipoterceroid_aux     = resp.data.equipoterceroid;
            this.nuevaprogramacion.coordinadorid_aux       = resp.data.coordinadorid;
            this.nuevaprogramacion.presupuestoplaneado_aux = resp.data.presupuestoplaneado;
            this.nuevaprogramacion.asunto_aux              = resp.data.asunto;
            this.nuevaprogramacion.descripcion_aux         = resp.data.descripcion ? resp.data.descripcion : '';
            this.nuevaprogramacion.fechafinal_aux          = resp.data.fechafinal;
            this.nuevaprogramacion.prioridadid_aux         = resp.data.prioridadid ? resp.data.prioridadid : '';
            this.nuevaprogramacion.colorhexadecimal_aux    = resp.data.colorhexadecimal ? resp.data.colorhexadecimal : '';
            this.nuevaprogramacion.nombrecliente           = resp.data.nombrecliente;
            this.nuevaprogramacion.nombreequipo            = resp.data.nombreequipo;
            this.nuevaprogramacion.nombresucursal          = resp.data.nombresucursal;
            this.nuevaprogramacion.dependenciaid           = resp.data.dependenciaid;
            this.nuevaprogramacion.nombrcomer              = resp.data.nombrcomer;
            this.nuevaprogramacion.razonsocial             = resp.data.razonsocial;
            this.nuevaprogramacion.nversion                = resp.data.nversion;
            this.nuevaprogramacion.visibilidad             = resp.data.visibilidad;

            this.visibilidad(this.nuevaprogramacion.visibilidad);
            this.nuevaprogramacion.cambiaversionactual     = resp.data.cambiaversionactual ? resp.data.cambiaversionactual : '0';

            this.validaversion                             = resp.data.cambiaversion == '1' ? true : false;
            this.obtenerContactoTercero(resp.data.clienteid,resp.data.sucursalid,0);
            if(this.nuevaprogramacion.sucursalid != ''){
                this.getEquipoTerceroSucursal(resp.data.sucursalid,resp.data.equipoterceroid,0);
            }
            this.obtenerSucursal(resp.data.clienteid,resp.data.equipoterceroid,resp.data.sucursalid);

            this.getVersionEquipo(resp.data.itemequipoid);
            this.obtenerTecnicosAsignadosPqr(this.nuevaprogramacion.detallepqrid);
            this.habilitarCampoTipoActividad(this.nuevaprogramacion.pqrid);
            this.obtenerNotasDetallePqr(this.nuevaprogramacion.pqrid);
            this.gettransicionestado(this.nuevaprogramacion.estadopqrid);
            this.getIncAsignada();
            this.setHeadpqrInsumos(resp.data.operacionid);

            //Si la incidencia esta cerrada se envia un estado desabled para no dejar hacer cambios en el tratamiento de la misma
            if (this.nuevaprogramacion.cierre == '1'){
              this.estadotablacerrarActividad = this.nuevaprogramacion.cierre;
              this.validaIncCierre  = '1';
              this.cumplida         = true;
              this.disabled         = true;
              this.disabledReabrir  = true;
              if (this.nuevaprogramacion.tipomantenimientoid == '1') {
                this.mostrarasignar = true;
              }
            }else{
              this.disabled         = false;
              this.disabledReabrir  = false;
              if (this.nuevaprogramacion.tipomantenimientoid == '1') {
                this.mostrarasignar = true;
              }else{
                this.mostrarasignar = false;
              }
            }

            resp.data.operacionid ? (this.nuevaprogramacion.validadoperaciontiempo = '1') :  (this.nuevaprogramacion.validadoperaciontiempo = '0');

            for(let i in this.estadosnombreArray){
              if(this.estadosnombreArray[i].id == resp.data.estadopqrid){
                this.nuevaprogramacion.estadopqridnombre_aux = this.estadosnombreArray[i].nombre;
              }
            }
            for(let i in this.serviciosArray){
              if(this.serviciosArray[i].id == resp.data.tiposervicioid){
                this.nuevaprogramacion.servicionombre = this.serviciosArray[i].nombre;
              }
            }
            this.operacionesTiempo(resp.data.itemequipoid, resp.data.operacionid,resp.data.operacion);
            for(let i in this.coordinadorArray){
              if(this.coordinadorArray[i].cedula == resp.data.coordinadorid){
                this.nuevaprogramacion.nombrecoordinador = this.coordinadorArray[i].nombreusuario;
              }
            }

            // Obtener listado de tecnicos asignados
            this.obtenerlistadotecnicodetallepqr(resp.data.detallepqrid);
            this.obtenerlistadotecnico(resp.data.coordinadorid);

            this._agendamiento.listActividadesIncidencia(resp.data.pqrid).subscribe((respuesta)=>{
              this.listActividades(resp.data.itemequipoid,respuesta);
            });

            $('.chos-unit select[multiple]').chosen({
              placeholder_text_single: 'Seleccione Opción'
              ,width: '100%'
              ,no_results_text: 'Ooops, no se encuentra'
            });
        }
      });
  }// .getRegAgendamiento(agendamientoid)

  /**
   * Permite abril un modal
   * JMM-2018-11-07
   */
  abrirModal(template:any, e){
    let self = this;
    this.validaversion = false;
    //validación que permite obtener la fecha en caso que se realice un evento clic sobre las celdas del formulario
    if (e) {
      var fecha_ini = e.start ? e.start.format() : '';
      var fecha_fin_aux = new Date(e.end.format());
      var ani_fin = fecha_fin_aux.getFullYear();
      var mes_fin = (fecha_fin_aux.getMonth()+1).toString();
      var dia_fin = (fecha_fin_aux.getDate()).toString();
      var fecha_fin = ani_fin + '-' + (mes_fin.length == 1 ? '0'+mes_fin : mes_fin) + '-' + (dia_fin.length == 1 ? '0'+dia_fin : dia_fin);
    }// .if


    this.arrayAgregarTecnicos = [];  //limpia campos de las tablas de los nuevos tecnicos
    this.TecnicoList = [];  //limpia campos de las tablas de los  tecnicos antes asignados

    //Bloque para sacar la hora automatica del sistema
    var  hours, minutes, seconds;
    var datehora = new Date();
    hours        = ("0" + datehora.getHours()).slice(-2);
    minutes      = ("0" + datehora.getMinutes()).slice(-2);
    seconds      = ("0" + datehora.getSeconds()).slice(-2);
    var fulltime = [hours, minutes, seconds].join(":");

    this.totalActividadesFamilia =[];
    this.totalActividades = [];

    //Campos del formulario
    this.disabledBtnGuardar = false;
    this.disabledcampo = false;
    this.accion = 'Crear';
    this.dataArryEquipo = [];
    this.mostrarCampo = false;
    this.totalActividadesFamilia = [];
    this.totalOperaciones = '';
    this.listactividadesFamilia = [];
    this.listoperaciones =  [];
    this.nuevaprogramacion.agendamientoid       = '';
    this.nuevaprogramacion.fechaagendaid        = '';
    this.nuevaprogramacion.detallepqrid         = '';
    this.nuevaprogramacion.alertapqrid          = '';
    this.nuevaprogramacion.tipomantenimientoid  = '';
    this.nuevaprogramacion.fecha                = fecha_ini ? fecha_ini : '';
    this.nuevaprogramacion.horainicial          = fulltime ? fulltime : '';

    $("#hora_Inicial_0").val(fulltime);
    this.nuevaprogramacion.horafinal            = fulltime ? fulltime : '';
    this.nuevaprogramacion.pqrid                = '';
    this.nuevaprogramacion.esproveedor          = null;
    this.nuevaprogramacion.ticket               = '';
    this.nuevaprogramacion.estado               = 'A';
    this.nuevaprogramacion.terceroid            = '';
    this.nuevaprogramacion.sucursalid           = '';
    this.nuevaprogramacion.equipoterceroid      = '';
    this.nuevaprogramacion.asunto               = '';
    this.nuevaprogramacion.tipopqrid            = null;
    this.nuevaprogramacion.tiposervicioid       = '';
    this.nuevaprogramacion.estadopqrid          = '';
    this.nuevaprogramacion.coordinadorid        = '';
    this.nuevaprogramacion.presupuestoplaneado  = '';
    this.nuevaprogramacion.descripcion          = '';
    this.nuevaprogramacion.tecnicoagendamiento  = [];
    this.tecnicoagendamientoArray               = [];
    this.nuevaprogramacion.fechafinal           = fecha_fin ? fecha_fin : '';
    this.nuevaprogramacion.prioridadid          = '';
    this.nuevaprogramacion.colorhexadecimal     = '';
    this.nuevaprogramacion.operacionid          = '';
    this.nuevaprogramacion.razonsocial          = '';
    this.nuevaprogramacion.nombrcomer           = '';
    this.nuevaprogramacion.cambiaversionactual  = '';
    this.nuevaprogramacion.validadoperaciontiempo = '';
    this.nuevaprogramacion.valor_frecuencia = '1',
    this.nuevaprogramacion.cantidad_inc     = '1';

    this.listTecnico = [];
    this.formnuevaprogramacion();
    this.formNuevaprogramacion.reset();
    this.obtenerUsuariosTipo('CO');

    if (this.tercerocreacionincidencia) {
        this.nuevaprogramacion.terceroid      = this.tercerocreacionincidencia + '=>' + this.nombretercero;
        this.nuevaprogramacion.razonsocial    = this.razonsocial;
        this.nuevaprogramacion.nombrcomer     = this.nombrcomer;
        this.estadopqrcliente(this.tercerocreacionincidencia);
        this.obtenerSucursal(this.tercerocreacionincidencia,null,null);
        this.obtenerEquiposTercero(this.tercerocreacionincidencia,null,1);
    }else{
        this.nuevaprogramacion.terceroid = '';
    }

    this.modalRef = this.modalService.show(template, {backdrop:'static', keyboard:false, class: 'gray modal-md modal_agendaiento'});

    $('.chos-unit select[unitario]').chosen({
        placeholder_text_single: 'Seleccione Opción'
      ,width: '100%'
      ,no_results_text: 'Ooops, no se encuentra'
    });

    $('.chos-unit select[multiple]').chosen({
        placeholder_text_single: 'Seleccione Opción'
      ,width: '100%'
      ,no_results_text: 'Ooops, no se encuentra'
    });

    $('.crearEditarPqr').off('change', ).on('change', function(e){
        e.preventDefault();
        self.onSelectEquipo($(this).val());
    });

    $('.creatEditSucursal').off('change', ).on('change', function(e){
      e.preventDefault();
      $('.crearEditarPqr').val('').trigger('chosen:updated').attr('disabled',true);
      $('.crearEditarPqr').val('').trigger('chosen:updated').attr('disabled',true);
      self.obtenerEquipos(null,1);
    });

    this.datafecha();
  }// .abrirModal(template:any, id)

  /**
   * Permite obtener el listado de coordinadores
   * JMM-2018-11-08
   */
  obtenerCoordinadores(){
    this._usuarios.getListUsuariosPorTipo('CO').subscribe((resp)=>{
      this.listCoordinador = resp.data;
      if(resp.data){
        let coordinadoresArray = new Array();
        for (let i = 0; i < resp.data.length; i++) {
          coordinadoresArray.push(resp.data[i]);
        }
        this.coordinadorArray = coordinadoresArray;
      }
      if(this.nuevaprogramacion.coordinadorid){
          this.obtenerlistadotecnico(this.nuevaprogramacion.coordinadorid);
      }
    });
  }//. obtenerCoordinadores()

  /**
   * Funcion que permite listar todos los tecnicos de la tabla segur
   */
  obtenerTecnicos(){
      this._usuarios.getListUsuariosPorTipo('TE').subscribe((resp)=>{
          if(resp.data){
              this.listatecnicossegur = resp.data;
          }
      });
  }

  /**
   * Función para optener el servicio por mantenimiento preventivo
   * JMM-2019-01-14
   */
  obtenerTipoServicio(){
    this._tiposervicio.getTipoServicio().subscribe((resp) => {
      if (this.agendartodotiposervicio == '1') {
        this.tiposervicios = resp.data;
      }else{
        this._tiposervicio.obtener_serviciopreventivo().subscribe((resp)=>{
          if (resp.data) {
            this.tiposervicios = resp.data;
            this.serviciosArray = resp.data;
          }
        });
      }
    });
  }

  /**
   * Función para optener el listado de Tipos de pqr
   * JMM-2018-07-11
   */
  obtenerTipoPqr(){
    this._tipopqr.getTipoPqr().subscribe((resp)=>{
      if (resp.data) {
          this.tipopqr = resp.data;
      }
    });
  }

  validatipopqr(){
    let self = this;
    var data : any;
    data = this.tipopqr.filter(function(car){
        return car.id == self.nuevaprogramacion.tipopqrid;
    });
    if(data.length > 0){
      this.validaversion = data[0].cambiaversion == 'SI' ? true : false;
      this.nuevaprogramacion.cambiaversionactual =  data[0].cambiaversion == 'SI' ? '1' : '0';

    }else{
      this.validaversion = false;
      this.nuevaprogramacion.cambiaversionactual = '0';
    }
  }

  /**
   * Función para optener el listado de las tipos de prioridad
   * CESAR ARIAS-2019-12-18
   */
  obtenerTipoprioridad(){
    this._prioridad.getPrioridad().subscribe((resp)=>{
      if (resp.data) {
          this.tiposprioridad = resp.data;
      }
    });
  }

  /**
   * Función para optener el listado de estados de la pqr
   * JMM-2018-11-08
   */
  obtenerEstadopqr(){
    this._estadopqr.getEstadopqr().subscribe((resp)=>{
      if (resp.data) {
        this.estadospqr = resp.data;
        let estadosArray = new Array();
        for (let i = 0; i < resp.data.length; i++) {
            estadosArray.push(resp.data[i]);
        }
        this.estadosnombreArray = estadosArray;
      }
    });
  }// .obtenerEstadopqr()

  /**
   * PERMITE PERMITE CONSULTAR LA LA TRANSACUION DEL ESTADO SEGUNE EL ESTADO EN EL QUE SE ENCUENTRE LA INCIDENCIA
   * CAAA-2019-09-19
  */
 gettransicionestado($estadopqrid){
    this.transicionestado = [];
    if($estadopqrid != null){
      this._estadopqr.gettransicionestado($estadopqrid).subscribe((resp)=>{
        if (resp.data) {
            this.transicionestado   = resp.data;
        }
      });
    }else{
      this.transicionestado = this.estadosnombreArray;
    }
 }// .gettransicionestado()


 /**
   * Permite obtener el listado de tecnicos de acuerdo al coordinador
   * JMM-2018-11-08
   */

  obtenerlistadotecnico(coordinadorid){
    if(this.nuevaprogramacion.esproveedor != 1){
      if(this.nuevaprogramacion.coordinadorid == ''){
        this.nuevaprogramacion.coordinadorid = coordinadorid;
      }

      this._terceros.getTecnicoCoordinador('10558335900').subscribe((respss)=>{
        this._terceros.getTecnicoCoordinador($("#coordinadorid").val()).subscribe((resp)=>{
          if (resp.data.length > 0) {
            this.listTecnicoporCordinador = resp.data;
          }else{
            this.listTecnicoporCordinador = [];
          }
        });
      });
      this.tecnicosotroscoordinadores = [];
      this.obtenerUsuariosAgendaTipo('CO',this.nuevaprogramacion.coordinadorid);
    }
  }

    /**
   * Permite obtener el listado de usuarios por tipo
   * JMM-2018-07-12
   */
  obtenerUsuariosAgendaTipo(tipo,coordinadorid){
    this.listcoordinadores_aux = [];
      this._usuarios.getListUsuariosPorTipo(tipo).subscribe((resp)=>{
        for (let i in resp.data) {
          if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid == null) {
            if ( (parseInt(resp.data[i].cedula)) != (parseInt(coordinadorid)) ) {
                this.listcoordinadores_aux.push(resp.data[i]);
            };
          };
        }
        this.nuevaprogramacion.coordinadorid = coordinadorid;
      });
  }// .obtenerUsuariosTipo(tipo)

   /**
   * Permite obtener el listado de tecnicos por coordinador
   * JMM-2019-01-24
   */
  obtenerOtrosTecnicosCoordinador(){
    let coordinadorid_aux = this.formNuevaprogramacion.value.otrocoordinadorid ? this.formNuevaprogramacion.value.otrocoordinadorid.split("-") : '';
    let coordinadorid = coordinadorid_aux[0] ? coordinadorid_aux[0].trim() : '';

    //Valida que llegue el coordinadorid y que sea diferente al usuario que se encuentre logueado
    if ( (coordinadorid != '') && (coordinadorid != this.getCedulaUsuario) && (coordinadorid != this.nuevaprogramacion.coordinadorid)){
      swal({
        title: 'Digite la clave del coordinador',
        html:
          this.formNuevaprogramacion.value.otrocoordinadorid + '<br>' +
          '<input type="password" id="coordinador_id" class="swal2-input" autocomplete="off">',
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        preConfirm: () => [$('#coordinador_id').val()]
      }).then(result => {
        if (result.value) {
          this._tratamientopqr.confirmar_clavecoordinadorAgenda(coordinadorid, result.value[0]).subscribe((resp)=>{
            if (resp.data == 'true'){
              this._terceros.getTecnicoCoordinador(coordinadorid).subscribe((resp)=>{
                let listtecnicos = new Array();
                for (let i in resp.data) {
                    if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid ==null) {
                      listtecnicos.push(resp.data[i]);
                    };
                }
                this.tecnicoscoordinadores_aux = listtecnicos;
                this.tecnicosotroscoordinadores = listtecnicos;
              });
            }// .if
            else {
                this.toastr.error('Clave incorrecta', 'Error', { timeOut: 3000 });
            }// .else
          });
        }// .if
      });
    }// .if
    //Valida que llegue el coordinadorid y que sea igual al usuarioque se encuentra logueado
    else if ( (coordinadorid != '') && (coordinadorid == this.getCedulaUsuario)){
      this._terceros.getTecnicoCoordinador(coordinadorid).subscribe((resp)=>{
        let listtecnicos = new Array();
        for (let i in resp.data) {
          if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid ==null) {
            listtecnicos.push(resp.data[i]);
          };
        }
        this.tecnicoscoordinadores_aux = listtecnicos;
        this.tecnicosotroscoordinadores = listtecnicos;
      });
    }else if ( (coordinadorid != '') && (coordinadorid == this.nuevaprogramacion.coordinadorid)){
      this._terceros.getTecnicoCoordinador(coordinadorid).subscribe((resp)=>{
        let listtecnicos = new Array();
        for (let i in resp.data) {
            if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid ==null) {
                listtecnicos.push(resp.data[i]);
            };
        }
        this.tecnicoscoordinadores = listtecnicos;
        this.tecnicoscoordinadores_aux = listtecnicos;
      });
    }
  }

  /**
   * Permite obtener el listado de tecnicos de acuerdo al coordinador
   * JMM-2018-11-08
   */
  obtenerlistadotecnicodetallepqr(detallepqrid){
    //Si llega el id del detalle de la pqr
    if (detallepqrid) {
      this._agendamiento.getTecnicosAsignados(detallepqrid).subscribe((resp)=>{
        if(resp.data){
          let listatecnicos = new Array();
          for(let i in resp.data){
              listatecnicos.push(resp.data[i].tecnicoid);
          }
          this.tecnicoagendamientoArray_aux = listatecnicos;
        }
        this.listTecnico_aux = [];
        for (let i in resp.data) {
          this.listTecnico_aux.push(resp.data[i].tecnicoid);
        }
        this.tecnicoagendamientoArray = this.listTecnico_aux;

        /**
         * Esta funcionalidad permite sacar el identificador y el nombre de los tecnicos selecionados
         * CESAR
         */
        for (let i in resp.data) {
          let semaforo  = 1;
          for (let j in this.tecnicoArray) {
            if(this.tecnicoArray[j].tecnicoid == resp.data[i].tecnicoid && this.tecnicoArray[j].detallepqrid == detallepqrid){
             if (semaforo == 1) {
              this.TecnicoList.push(this.tecnicoArray[j]);
              semaforo = 0;
             }
            }
          }
        }
      });

    }
  }


   /**
   * Función para obtener el listado del Agendamiento de la app
   * JMM-2018-11-14
   */
  getAgendamientoFiltros(){
      //envia el listado de permisoa para cargar las incidencias
      let listadopermisos = {
        'especiales_verCliente_Sucursal_por_usuario': this.listpermisos.especiales_verCliente_Sucursal_por_usuario,
        'permiso_vertodaslasincidencias' : this.listpermisos.especiales_vertodaslasincidencias,
        'especiales_vertodaslasincidencias_por_dependencia' : this.listpermisos.especiales_vertodaslasincidencias_por_dependencia,
        'especiales_vertodas_incidencias_reportadas_por_usuario' : this.listpermisos.especiales_vertodas_incidencias_reportadas_por_usuario,
        'usuario' : localStorage.getItem('usuarioid'),
        'cedulaUsuario' : localStorage.getItem('usuarioid'),
      }

    this._agendamiento.getRegistrosAgendaPermiso(listadopermisos).subscribe((resp)=>{
      if(resp.data){
          //FILTRO ZONA
          var parametroTecnico_aux = {};
          var parametrocodigointerno_aux = {};
          var parametropqrid_aux = {};
          var parametroticket_aux = {};
          for(var i in resp.data){
            parametroTecnico_aux[resp.data[i]['tecnicoid']] = resp.data[i];
            parametrocodigointerno_aux[resp.data[i]['codigointerno']] = resp.data[i];
            parametropqrid_aux[resp.data[i]['pqrid']] = resp.data[i];
            parametroticket_aux[resp.data[i]['ticket']] = resp.data[i];
          }

          for (i in parametropqrid_aux) {
            if(parametropqrid_aux[i].pqrid){
              this.statesPqr.push({
                'pqrid'     : parametropqrid_aux[i].pqrid,
              });
            }
          }

          for (i in parametroticket_aux) {
            if(parametroticket_aux[i].ticket){
              this.statesTicket.push({
                'ticket'   : parametroticket_aux[i].ticket,
              });
            }
          }
        }
    });
  }

  /**
   * Permite obtener el listado de terceros por tipo
   * JMM-2018-11-08
   */
  obtenerTerceros(tipo){
      this._terceros.getListTerceros(tipo).subscribe((resp)=>{
        if (tipo == 'C') {
          if (resp.data.length > 0){
            //DATALIST
            //Se recorren los datos y se llena un array con la clave del identificador del tercero
            this.statesClienteCrearl = [];
            var parametroCliente_aux = {};
            for (var i in resp.data) {
              parametroCliente_aux[resp.data[i]['terceroid']] = resp.data[i];
            }
            //Se recorre nuevamente el array con la clave del identificador del tercero y se eliminan los duplicados
            for (let i in parametroCliente_aux) {
              this.statesClienteCrearl.push({
                'terceroid'      : parametroCliente_aux[i].terceroid,
                'nombre'         : parametroCliente_aux[i].nombre,
                'nombrcomer'     : parametroCliente_aux[i].nombrcomer,
                'nombreestadopqr': parametroCliente_aux[i].nombreestadopqr,
                'observacion'    : parametroCliente_aux[i].observacion,
                'estadopqrid'    : parametroCliente_aux[i].estadopqrid,
                'primaestado'    : parametroCliente_aux[i].primaestado,
                'razonsocial'    : parametroCliente_aux[i].razonsocial,
                'infoclientel'   : parametroCliente_aux[i].terceroid + '=>' + ( parametroCliente_aux[i].nombre ? parametroCliente_aux[i].nombre : parametroCliente_aux[i].razonsocial)
              });
            }

            let terceroArray = new Array();
            for (let i = 0; i < resp.data.length; i++) {
              terceroArray.push(resp.data[i]);
            }
            this.clienteArray = terceroArray;
          } else {
            this.sindatos = 'No hay datos.';
          }
        }else{
          this.listProveedor = [];
          for (var i in resp.data) {
            resp.data[i].cedula = resp.data[i].terceroid;
            resp.data[i].nombreusuario = resp.data[i].nombre;
            this.listProveedor.push(resp.data[i]);
          }
          this.proveedorFicha(this.itemequipoidpqr);
        }
      });
  }

  /**
   * Permite obtener el listado de sucursales
   * JMM-2018-11-08
   */
  obtenerSucursal(terceroid,equipoterceroid,sucursalid){
    let self = this;
    this.statesSucursalCrear = [];
    this._sucursal.getSucursales(terceroid).subscribe(resp=>{
      this.mostrarBotonHabilitarModificar = true;
      this.sucursalArray = resp.data;
      setTimeout(function(){
        $('.creatEditSucursal').val('').trigger('chosen:updated').attr('disabled',false);
        $('.creatEditSucursal').val('').trigger('chosen:updated').attr('disabled',false);
        if(self.accion !='Crear'){
          $('.creatEditSucursal').val(sucursalid).trigger('chosen:updated').attr('disabled',true);
          $('.creatEditSucursal').val(sucursalid).trigger('chosen:updated').attr('disabled',true);
        }
      },500);
    });
  }

  /**
   * Permite obtener el listado de equipos por tercero
   * JMM-2018-11-08
   */
  obtenerEquiposTercero(terceroid,equipoterceroid,valida){
    this._equipoTercero.listEquipoTerceroPorTercero(terceroid).subscribe(respuesta=>{
      this.equipoArray = respuesta.data;
      this.dataArryEquipo = [];
      this.statesEquipoCrear = [];
      var parametroEquipo_aux = {};
      for (var i in respuesta.data) {
        parametroEquipo_aux[respuesta.data[i]['equipoterceroid']] = respuesta.data[i];
      }
        //Se asigna un dato vacio como cabecera del array
      this.statesEquipoCrear.push({'equipoterceroid' : '' });
        //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
      for (i in parametroEquipo_aux){
        this.statesEquipoCrear.push({
          'itemequipoid'   : parametroEquipo_aux[i].itemequipoid,
          'equipoterceroid': parametroEquipo_aux[i].equipoterceroid,
          'nombre'         : parametroEquipo_aux[i].nombreequipo,
          'serial'         : parametroEquipo_aux[i].serial,
          'familiaid'      : parametroEquipo_aux[i].familiaid,
          'nombretecnico'  : parametroEquipo_aux[i].nombretecnico,
          'coordinadorid'  : parametroEquipo_aux[i].coordinadorid,
          'nombreestado'   : parametroEquipo_aux[i].nombreestado,
          'nombrefamilia'  : parametroEquipo_aux[i].familiaid ? parametroEquipo_aux[i].nombrefamilia : '',
          'infoequipo'     : parametroEquipo_aux[i].equipoterceroid+' => '+parametroEquipo_aux[i].nombreequipo +' - '+parametroEquipo_aux[i].modelo + ' - ' +parametroEquipo_aux[i].nombremarca
            + (parametroEquipo_aux[i].serial != ''? ' Serial->'+ parametroEquipo_aux[i].serial : '')
            + (parametroEquipo_aux[i].codigointerno ? ' C.Interno - '+ parametroEquipo_aux[i].codigointerno : '')
        });
      }
      setTimeout(function(){
        $('.chosen-select').val('').trigger('chosen:updated').attr('disabled',false);
        if(valida == 1){
          $('.crearEditarPqr').val('').trigger('chosen:updated').attr('disabled',false);
          $('.crearEditarPqr').val('').trigger('chosen:updated').attr('disabled',false);
          $('.creatEditSucursal').val('').trigger('chosen:updated').attr('disabled',false);
          $('.creatEditSucursal').val('').trigger('chosen:updated').attr('disabled',false);
          $('.contactoid').val('').trigger('chosen:updated').attr('disabled',false);
          $('.contactoid').val('').trigger('chosen:updated').attr('disabled',false);
        }else{
          if(equipoterceroid){
            $('.crearEditarPqr').val(equipoterceroid).trigger('chosen:updated').attr('disabled',true);
            $('.crearEditarPqr').val(equipoterceroid).trigger('chosen:updated').attr('disabled',true);
          }
        }
      },500);
    });
  }

  /**
   * Obtener listado de equipos por sucursal de un tercero
   * JMM-2018-11-08
   */
  getEquipoTerceroSucursal(sucursalid,equipoterceroid,valida){
    let self = this;
    this.statesEquipoCrear = [];
    this._equipoTercero.listEquipoTerceroPorTerceroSucursal(sucursalid).subscribe((resp)=>{
      this.equipoArray = resp.data;
      this.dataArryEquipo = [];
      for (let i in resp.data) {
        this.statesEquipoCrear.push({
          'itemequipoid'    : resp.data[i].itemequipoid,
          'equipoterceroid' : resp.data[i].equipoterceroid,
          'nombre'          : resp.data[i].nombreequipo,
          'serial'          : resp.data[i].serial,
          'familiaid'       : resp.data[i].familiaid,
          'nombretecnico'   : resp.data[i].nombretecnico,
          'coordinadorid'   : resp.data[i].coordinadorid,
          'nombreestado'    : resp.data[i].nombreestado,
          'nombrefamilia'   : resp.data[i].familiaid ? resp.data[i].nombrefamilia : '',
          'infoequipo'      : resp.data[i].equipoterceroid+' => '+resp.data[i].nombreequipo +' - '+resp.data[i].modelo + ' - ' +resp.data[i].nombremarca
          + (resp.data[i].serial != ''? ' Serial->'+ resp.data[i].serial : '')
          + (resp.data[i].codigointerno ? ' C.Interno - '+ resp.data[i].codigointerno : '')
        });
      }

      setTimeout(function(){
        if(self.accion == 'Crear'){
          $('.crearEditarPqr').val('').trigger('chosen:updated').attr('disabled',false);
          $('.crearEditarPqr').val('').trigger('chosen:updated').attr('disabled',false);
        }else{
          if(valida == 1){
            $('.crearEditarPqr').val('').trigger('chosen:updated').attr('disabled',false);
            $('.crearEditarPqr').val('').trigger('chosen:updated').attr('disabled',false);
            $('.creatEditSucursal').val(sucursalid).trigger('chosen:updated').attr('disabled',false);
            $('.creatEditSucursal ').val(sucursalid).trigger('chosen:updated').attr('disabled',false);
          }else{
            $('.crearEditarPqr').val(equipoterceroid).trigger('chosen:updated').attr('disabled',true);
            $('.crearEditarPqr').val(equipoterceroid).trigger('chosen:updated').attr('disabled',true);
            $('.creatEditSucursal ').val(sucursalid).trigger('chosen:updated').attr('disabled',true);
            $('.creatEditSucursal ').val(sucursalid).trigger('chosen:updated').attr('disabled',true);
          }
        }
      },500);
    });
  }

  /**
   * Funciones Datalist para seleccionar los registros
   * JMM-2018-11-08
   */
  onSelectCliente(event: TypeaheadMatch) : void {
    this.primaestado         = event.item.primaestado;
    this.estadopqridCliente  = event.item.estadopqrid;
    this.nombreestadocliente = event.item.nombreestadopqr ? event.item.nombreestadopqr : '';
    this.observacionCliente  = event.item.observacion;

    this.selectedOptionCliente         = event.item.terceroid;
    this.nuevaprogramacion.razonsocial = event.item.razonsocial;
    this.nuevaprogramacion.nombrcomer  = event.item.nombrcomer;
    this.totalActividades              = [];
    this.totalActividadesFamilia       = [];
  }

  estadopqrcliente(terceroid){
    this._estadopqr.estadopqrcliente(terceroid).subscribe((resp)=>{
      this.primaestado         = resp.data.primaestado ? resp.data.primaestado : '';
      this.estadopqridCliente  = resp.data.estadopqrid ? resp.data.estadopqrid : '';
      this.nombreestadocliente = resp.data.nombreestado;
      this.observacionCliente  = resp.data.observacion;
    });
  }

  onSelectEquipo(equipoterceroid) : void {
      let validaFunction = 0;
      this._agendamiento.setDatoEquipo(equipoterceroid).subscribe((resp)=>{
        this.itemequipoidpqr = resp.data.itemequipoid;
          let dataEquipo = {
              'equipoterceroid' : resp.data.equipoterceroid,
              'nombre'          : resp.data.nombre,
              'serial'          : resp.data.serial,
              'familiaid'       : resp.data.familiaid,
              'nombrefamilia'   : resp.data.nombrefamilia,
              'itemequipoid'    : resp.data.itemequipoid,
              'nombreestado'    : resp.data.nombreestado,
              'nversion'        : resp.data.nversion,
              'operacionid'     : '',
          }

          if(this.accion=='Editar'){
              this.totalActividades = [];
              this.totalActividadesFamilia = [];
              this.dataArryEquipo = [];
              this.dataArryEquipo.push(dataEquipo);
              validaFunction = 1;
          }else{
              if(resp.data.nombretecnico != null){
                this.agregarTecnicos(3,resp.data.nombretecnico); ///suspendido temporalmente
              }
              this.obtenerlistadotecnico(resp.data.coordinadorid);
              if (this.dataArryEquipo.length > 0) {
                  let data = 0;
                  for(let i in this.dataArryEquipo){
                    if (this.dataArryEquipo[i].itemequipoid == this.itemequipoidpqr ) {
                      data = data + 1;
                    }
                  }
                  if (data == 0) {
                    this.dataArryEquipo.push(dataEquipo);
                    validaFunction = 1;
                  }else{
                    this.toastr.warning('El Equipo ya se encuentra Asignado a la incidencia', 'Alerta', { timeOut: 3000 });
                    return;
                  }
              }else{
                  this.dataArryEquipo.push(dataEquipo);
                  validaFunction = 1;
              }
          }

          if(this.nuevaprogramacion.esproveedor == 1){
              this.proveedorFicha(this.itemequipoidpqr);
          }

          if (validaFunction > 0){
              this.selectedOptionEquipo = dataEquipo;
              let data = ($('#infoequipo').val().replace('<em>','').replace('</em>','')); // elimina etiquetas de la cadena de texto
              $('#infoequipo').val(data);
              this.listOperacionesItemequipo(this.itemequipoidpqr);
              this.listActividadesItemequipo(this.itemequipoidpqr);
              this.operacionesTiempo(this.itemequipoidpqr,null,null);
              if(this.servicio == '1'){
                this.getversiondisponible(this.itemequipoidpqr);
              }
          }
    });
  }

    /**
   * Función para quitar un registro del listado de tecnicos asignados
   * JMM-2018-10-25.
   */
  quitarTecnicoAsignadoEnListado(indice){
    this.dataArryEquipo.splice(indice, 1); //elimina un elemento del arreglo segun indice
    this.totalActividades.splice(indice, 1); //elimina un elemento del arreglo segun indice
  }

    /**
   * Función para quitar un registro del listado de tecnicos asignados
   * CESAR ARIAS-2019-08-28
   */
  quitarTecnicoAntesasignado(indice){
    this.TecnicoList.splice(indice, 1); //elimina un elemento del arreglo segun indice
  }

  onSelectOperacion(event: TypeaheadMatch): void { this.nuevaprogramacion.operacionid= event.item.operacionid;}
  typeaheadNoResultsCliente(event: boolean)   : void { this.noResultCliente = event; }
  typeaheadNoResultsSucursal(event: boolean)  : void { this.noResultSucursal = event; }
  typeaheadNoResultsEquipo(event: boolean)    : void { this.noResultEquipo = event; }
  typeaheadNoResultsOperacion(event: boolean): void { this.noResultOperacion = event; }

  listOperacionesItemequipo(itemequipoid){
    this.listoperaciones = [];
    this._equipoTercero.listOperacionesItemequipo(itemequipoid).subscribe((resp) => {
      this.listoperaciones = resp.data;
      this.totalOperaciones = resp.data.length;
    });
  }

  getversiondisponible(itemequipoid){
    this._versiones.getversiondisponible(itemequipoid).subscribe((resp) => {
        if(this.accion =='Crear'){
            if (resp.data.length >0) {
              let dataVersionimput = "<select data-versionid list='allVersionNames_"+itemequipoid+"' data-itemequipoid='"+itemequipoid+"' style='width: 116px;' placeholder='Seleccione Versión...' class='form-control input_form idchange' value='' autocomplete='off'>";
                dataVersionimput += "<option disabled value='' selected></option>";
              for (let i in resp.data){
                dataVersionimput += "<option value='"+resp.data[i].versionid+"'>"+resp.data[i].nversion +"</option>";
              }
              dataVersionimput += "</select>";
              $("#dataVersionImput_"+itemequipoid).html(dataVersionimput);
            }
        }
    })
  }

  /**
   * olista todas las operacionesde tiempo del equipo inventariado
   * CESAR ARIAS -2019-05-07
   */
  operacionesTiempo(itemequipoid,operaionid,operacion){
    if(this.nuevaprogramacion.esproveedor != 1){
      this.terceroresponsable(itemequipoid);
    }else{
      if(this.nuevaprogramacion.pqrid == null){
        this.proveedorFicha(itemequipoid);
      }
    }

    this._pqr.operacionesTiempo(itemequipoid).subscribe((resp) => {
      ///valida si es crear carga los campos de operación en la tabla de los equipo de lo contrario carga un solo campo operación
      if(this.accion =='Crear'){
            if (resp.data.length >0) {
              let contenido = "";
              let dataimput = "<input data-operacion list='allNames_"+itemequipoid+"' data-itemequipoid='"+itemequipoid+"' style='width: 250px;' placeholder='Seleccione Operación...' class='form-control input_form idchange' value='' autocomplete='off'>";
              $("#dataImput_"+itemequipoid).html(dataimput);
              for (let i in resp.data){
                if(resp.data.estadoActividad == 'A' && resp.data.estadoOperacion == 'A'){
                  contenido = contenido + "<option value='"+resp.data[i].operacionid+'=>'+resp.data[i].operacion+"'></option>";
                }
              }
              $("#allNames_"+itemequipoid).html(contenido);
            }
      }else{
        this.statesOperacion = [];
        //DATALIST OPERACIONES DE TIEMPO
        var parametroOperacioniempo_aux = {};
        for (var i in resp.data) {
          parametroOperacioniempo_aux[resp.data[i]['operacionid']] = resp.data[i];
        }

        //Se asigna un dato vacio como cabecera del array
        this.statesOperacion.push({'operacionid' : '' });
        //Se recorre nuevamente el array con la clave del identificador de la operacion y se eliminan los duplicados
        for (i in parametroOperacioniempo_aux)
        {
          this.statesOperacion.push({
            'itemequipoid' : parametroOperacioniempo_aux[i].operacionid,
            'nombre'       : parametroOperacioniempo_aux[i].operacion,
            'infooperacion'   : parametroOperacioniempo_aux[i].operacionid+' => '+parametroOperacioniempo_aux[i].operacion
          });
          }
          if (operaionid){
            this.statesOperacion[0] = operaionid + ' => '+ operacion;
          }else{
            this.statesOperacion[0] = '';
          }
        }
    });
  }

  terceroresponsable(itemequipoid){
    this._equipoTercero.terceroresponsable(itemequipoid).subscribe((resp) => {
        this.nuevaprogramacion.coordinadorid = resp.data[0].coordinadorid;
    });
  }

  proveedorFicha(itemequipoid){
    let seft = this;
    if(itemequipoid){
      this._pqr.proveedorFicha(itemequipoid).subscribe((resp)=>{
        if(resp.data.length > 0){
          this.nuevaprogramacion.coordinadorid = resp.data[0].proveedor.trim();
          setTimeout(function(){
            seft.agregarTecnicos(1,null);
          },500);
        }
      });
    }
  }
  /**
   * olista todas las activiadades por defaul del equipo y los coloca chekeados
   * CESAR ARIAS -2019-05-06
   */
    listActividadesItemequipo(itemequipoid){
      this.listoperaciones = [];
      this.totalActividadesFamilia = [];
        $(".equipoid").prop('disabled',true);
      this._equipoTercero.listActividadesItemequipo(itemequipoid).subscribe((resp) => {
        $(".equipoid").prop('disabled',false);
        if (resp.data.length > 0) {
          for (let i in resp.data){
            this.totalActividadesFamilia.push(
              { actividadpqr: '1',
                actividadid: resp.data[i].tipoactividadid,
                pqrid: '',
                nombre : resp.data[i].nombre,
                nombrefamilia : resp.data[i].nombrefamilia
              })
          }

          //consulta si el itemequipo ya tiene actividades cargados para no duplicar información
          let validador = 0;
          for (let j in this.totalActividades){
            if (itemequipoid == this.totalActividades[j].itemequipoid) {
              validador = validador + 1;
            }
          }
          if (validador == 0) {
            this.totalActividades.push({
              itemequipoid            : itemequipoid, // cesar22
              familia                 : resp.data[0].nombrefamilia,
              nombreequipo            : resp.data[0].nombreequipo,
              serial                  : resp.data[0].serial,
              totalActividadesFamilia : this.totalActividadesFamilia});
          }
        }
      });
    }

    /**
   * Permite habilitar los campos para actualizar los datos
   * CESAR ARIAS -2019-05-06
   */
    listActividades(itemequipoid,dataactividad){
      this.totalActividadesFamilia =[];
      this.totalActividades = [];
      this._equipoTercero.listActividadesItemequipo(itemequipoid).subscribe((resp) => {
        for (let i in resp.data) {
          let param = 0;
          for (let j in dataactividad.data) {
            if (resp.data[i].tipoactividadid == dataactividad.data[j].actividadid) {
              param = param + 1;
              this.totalActividadesFamilia.push(dataactividad.data[j]);
            }
          }
          if (param == 0) {
            this.totalActividadesFamilia.push(
              { actividadpqr: '0',
                actividadid: resp.data[i].tipoactividadid,
                pqrid: '',
                nombre : resp.data[i].nombre
              }
            )
          }

          if(this.accion != 'Crear'){
              this.totalActividades = [];
          }
          this.totalActividades.push({
            itemequipoid            : itemequipoid, // cesar22
            familia                 : resp.data[0].nombrefamilia,
            nombreequipo            : resp.data[0].nombreequipo,
            serial                  : resp.data[0].serial,
            totalActividadesFamilia : this.totalActividadesFamilia
          });
        }
      });
    }

  /**
   * Permite habilitar los campos para actualizar los datos
   * JMM-2018-11-13
   */
  habilitarModificar(){
    this.accion = 'Editar';
    $("#contOperacion").removeClass("hidden");
    this.disabledcampo = false;
    this.disabledBtnGuardar = false;
    this.mostrarBotonHabilitarModificar = false;
    $('.crearEditarPqr').trigger('chosen:updated').attr('disabled',false);
    $('.crearEditarPqr').trigger('chosen:updated').attr('disabled',false);
    $('.creatEditSucursal').trigger('chosen:updated').attr('disabled',false);
    $('.creatEditSucursal').trigger('chosen:updated').attr('disabled',false);
    $('.contactoid').trigger('chosen:updated').attr('disabled',false);
    $('.contactoid').trigger('chosen:updated').attr('disabled',false);
    $('.btnEditarHE').attr('disabled',false);
    $('.btnEliminar').attr('disabled',false);
  }

  /**
   * Permite obtener los equipos
   * JMM-2018-11-14
   */
  obtenerEquipos(terceroid,valida){
    let sucursal  = $(".creatEditSucursal").val();
    this.totalActividades = [];
    this.totalActividadesFamilia = [];
    let sucursalid = sucursal ? sucursal : null ;
    if (terceroid && sucursalid == null) {
      this.obtenerEquiposTercero(terceroid,null,valida);
    } else if (sucursalid && terceroid == null) {
      this.getEquipoTerceroSucursal(sucursalid,null,valida);
    }

    let terceroid_aux = this.formNuevaprogramacion.value.terceroid ? this.formNuevaprogramacion.value.terceroid.split("=>") : '';
    let cliente = terceroid_aux[0] ? terceroid_aux[0].trim() : '';
    $('.crearEditarPqr').val('').trigger('chosen:updated').attr('disabled',false);
    this.nuevaprogramacion.coordinadorid = '';
    this.obtenerContactoTercero(cliente,sucursal,valida);
  }

  /**
   * Función para obtener el agendamiento segun filtro
   * JMM-2018-11-15
   */
  getFiltroAgendamiento(pqrid){
    this.mostrarpreloader = true;
    this._agendamiento.getRegistroAgendamiento(null, pqrid).subscribe((res)=>{
      if (res.data){
        this.mostrarpreloader = false;
        //Preparación de los datos para enviarlos al calendario
        this.data = [];
        for (let i in res.data){
          if (res.data[i].estado_actualizado == 1) {
            let fechafinal;
            //Validación para aumentar un dia y que se pueda visualizar bien
            if (res.data[i].fechafinal){
              let array_fechafinal = res.data[i].fechafinal.split("-");
              let anio = parseInt(array_fechafinal[0]);
              let mes = parseInt(array_fechafinal[1]);
              let dia_aux = parseInt(array_fechafinal[2]);
              let dia = dia_aux + 1;
              fechafinal = anio+'-'+mes+'-'+dia;
            }// .if

            //Arreglo para enviar los datos que se visualizan en el calendario
            let TipoEncargado = 'Técnico:     ';
            if(res.data[i].esproveedor ==1){
              TipoEncargado = 'Proveedor:     '
            }

            let  nombrecliente     = res.data[i].nombrecliente     ? res.data[i].nombrecliente :'';
            let  nombresucursal    = res.data[i].nombresucursal    ? res.data[i].nombresucursal :'';
            let  nombreadquisicion = res.data[i].nombreadquisicion ? res.data[i].nombreadquisicion :'';
            let  codigointerno     = res.data[i].codigointerno     ? res.data[i].codigointerno :'';
            let  operacion         = res.data[i].operacion     ? res.data[i].operacion :'';
            let  nombrcomer        = res.data[i].nombrcomer    ? res.data[i].nombrcomer :'';

            this.data.push({
              pqrid           : res.data[i].pqrid,
              agendamientoid  : res.data[i].agendamientoid,
              title           : '   Cliente:           ' + nombrecliente +
                                ' \nSucursal:          ' + nombresucursal +
                                ' \nN.Comercial:       ' + nombrcomer  +
                                ' \nINC:               ' + res.data[i].pqrid +
                                ' \nCódigo Interno:    ' + codigointerno  +
                                ' \nAdquisición:       ' + nombreadquisicion  +
                                ' \nOperación:         ' + operacion  +
                                ' \n'+ TipoEncargado  + res.data[i].tecnicoid + ' - ' + res.data[i].nombretecnico +
                                ' \nHora Inicio: ' + res.data[i].horainicial + ' - Hora Fin: ' + res.data[i].horafinal +
                                ' \nVisibilidad:      ' +  res.data[i].visibilidad,
              start           : res.data[i].fecha,
              end             : fechafinal,
              backgroundColor : '#337ab7',
              borderColor     : (res.data[i].nombrevisibilidad == 'Privado' ? '#64d07f' : res.data[i].colorhexadecimal)
            });
          }
        }// .for
        //Enviar los datos al calendario
        this.calendarOptions = {
          editable : true,
          eventLimit : false,
          header : {
            left : 'prev,next, today',
            center : 'title',
            right : 'listYear ,month, agendaWeek, agendaDay'
          },
          locale:'es',
          events : this.data
        };
      }
      else {
        this.mostrarpreloader = true;
      }
    });
  }

  visibilidad(param){
    if(param == 1){
      this.nuevaprogramacion.visibpublic = false;
      this.nuevaprogramacion.visibprivad = true;
    }else{
      this.nuevaprogramacion.visibpublic = true;
      this.nuevaprogramacion.visibprivad = false;
    }
  }


  /**
   * Permite enviar la petición para guardar los datos
   * CESAR ARIAS ARCILA-2019-05-06
   */
  submit(){
    //Arreglo de datos dinamicos
    let arregloDatosTecnicos1 = new Array;
    for (let i in this.arrayAgregarTecnicos){
        if (this.arrayAgregarTecnicos[i] != undefined){
          let objetoDatosTecnicos = {
            'tecnicoid' : this.arrayAgregarTecnicos[i].tecnicoid,
            'costoproveedor' : $('#costoProveedorNuevo_'+i).val() ?  $('#costoProveedorNuevo_'+i).val() : null
          };
          arregloDatosTecnicos1.push(objetoDatosTecnicos);
        }
      }

      for (let j in this.TecnicoList){
          if (this.TecnicoList[j] != undefined){
            let objetoDatosTecnicos = {
              'tecnicoid'      : this.TecnicoList[j].tecnicoid,
              'costoproveedor' : $('#costoProveedorAntes_'+j).val() ?  $('#costoProveedorAntes_'+j).val() : null
            };
            arregloDatosTecnicos1.push(objetoDatosTecnicos);
          }
      }

    this.nuevaprogramacion.visibilidad = this.formNuevaprogramacion.value.visibprivad == true ? 1 : 0;
    this.formNuevaprogramacion.value.tecnicoagendamiento = arregloDatosTecnicos1;

    //recorre los campos de la tabla y almacena las operaciones seleccionadas
    let dataOperacion = new Array();
    let dataVersion   = new Array();
    $('.equipo').find('tr:not(:eq(0))').each(function(){
      var objeOperacion = {
        operacionid: $(this).find('td:eq(6) input').attr('data-operacion'),
        itemequipoid: $(this).find('td:eq(6) input').attr('data-itemequipoid'),
      }
      if(objeOperacion.operacionid != undefined && objeOperacion.operacionid != ''){
        dataOperacion.push(objeOperacion);
      }

      var objeversiones = {
        versionid: $(this).find('td:eq(5) option:selected').val(),
        itemequipoid: $(this).find('td:eq(5) select').attr('data-itemequipoid'),
      }

      if(objeversiones.versionid != undefined && objeversiones.versionid != ''){
        dataVersion.push(objeversiones);
      }
    });

    this.dataOpercionid = dataOperacion;
    this.dataVersionid  = dataVersion;
    this.NombreCliete = '';

    let nombretercero = this.formNuevaprogramacion.value.nombre ? this.formNuevaprogramacion.value.nombre :this.formNuevaprogramacion.value.razonsocial;
    //Bloque para: Se realiza un split para sacar los identificadores:
    let terceroid_aux = this.formNuevaprogramacion.value.terceroid ? this.formNuevaprogramacion.value.terceroid.split("=>") : '';
    this.formNuevaprogramacion.value.terceroid = terceroid_aux[0] ? terceroid_aux[0].trim() : '';
    this.NombreCliete = terceroid_aux[1] ? terceroid_aux[1].trim() : '';
    this.formNuevaprogramacion.value.sucursalid = $('.creatEditSucursal').val();

    this.formNuevaprogramacion.value.contactoid = $(".contactoid").val();
    this.formNuevaprogramacion.value.equipoterceroid = $('.crearEditarPqr').val();

    let operacionid_aux = this.formNuevaprogramacion.value.operacionid ? this.formNuevaprogramacion.value.operacionid.split("=>") : '';
    this.formNuevaprogramacion.value.operacionid = operacionid_aux[0] ? operacionid_aux[0].trim() : '';

    var selected = [];
    $("input[data-checkbox=checkbox_1]").each(function(){
      let itemequipo_aux = $(this).val() ? $(this).val().split("-") : '';
      let itemequipoid = itemequipo_aux[1] ? itemequipo_aux[1].trim() : '';
      let actividadid = itemequipo_aux[0] ? itemequipo_aux[0].trim() : '';

      if ($(this).is(":checked")){
          selected.push({
            'actividadid'      : actividadid,
            'pqrid'            :   '',
            'esactividadpqr'  :    '1',
            'itemequipoid'     : itemequipoid
          });
      } else {
          selected.push({
            'actividadid'      : actividadid,
            'pqrid'           :   '',
            'esactividadpqr' :    '0',
            'itemequipoid'     : itemequipoid
          });
      }
      }
    );
    this.formNuevaprogramacion.value.actividadid = selected;

    let fecha = new Array();
    $('.fecha').each(function(){
     fecha.push({'fecha' : $(this).val()});
    });

    let fechafinal = new Array();
    $('.fechafinal').each(function(){
     fechafinal.push({'fechafinal' : $(this).val()});
    });

    let horainicial = new Array();
    $('.horainicial').each(function(){
     horainicial.push({'horainicial' : $(this).val()});
    });

    let horafinal = new Array();
    $('.horafinal').each(function(){
     horafinal.push({'horafinal' : $(this).val()});
    });

    let array_aux = new Array();
    for(let i in fecha){
      array_aux.push({
        'fechaInicial' : fecha[i].fecha +' '+horainicial[i].horainicial,
        'fechaFinal'   : fechafinal[i].fechafinal +' '+horafinal[i].horafinal
      })
    }

    let count = 0;
    for(let i in array_aux){
        if(array_aux[i].fechaInicial > array_aux[i].fechaFinal){
          count +=1;
          $("#line_"+i).css('background',this.colorRGB());
        }else{
          $("#line_"+i).css('background','none');
        }
    }

    if(count > 0){
        this.toastr.error('La fecha final debe ser igual o mayor a la fecha Inicial, verifique la zona coloreada', 'Error', { timeOut: 3000 });
        this.disabledBtnGuardar = false;
        return;
    }

     //Si validacion erronea del formulario muestra mensaje
    if (!this.formNuevaprogramacion.valid) {
      this.disabledBtnGuardar = false;
      this._valid.touched(this.formNuevaprogramacion);
      this.toastr.error('Campos obligatorios *', 'Error', { timeOut: 3000 });
    }
    //Si no se ha seleccionado un técnico de la lista
    else if (this.formNuevaprogramacion.value.tecnicoagendamiento == '' && $('#tecnicoagendamiento').val() == '') {
      this.disabledBtnGuardar = false;
      this._valid.touched(this.formNuevaprogramacion);
      this.toastr.error('Debe seleccionar al menos un técnico de la lista', 'Error', { timeOut: 3000 });
    }
    //De lo contrario modifica o crea el registro
    else {
      if(this.accion != 'Crear'){
        if(!this.formNuevaprogramacion.value.equipoterceroid){
            this.toastr.error('Campos Equipo es obligatorio *', 'Error', { timeOut: 3000 });
            return;
        }
      }

      if (this.formNuevaprogramacion.value.agendamientoid > 0) {
        this.enviarModificar(this.formNuevaprogramacion.value.agendamientoid,fecha,fechafinal,horainicial,horafinal);
      } else {
        this.enviarCrear(fecha,fechafinal,horainicial,horafinal,nombretercero);
      }
    }
  }// .submit()

   /**
   * Obtener el listado de usuarios segun el perfil
   * JMM-2018-07-10
   */
  obtenerUsuariosTipo(tipo){
    this._usuarios.getListUsuariosPorTipo(tipo).subscribe((resp)=>{
      // carga el estado por defecto de la tabla montaje//
      if(this.accion == 'Crear'){
        this.nuevaprogramacion.estadopqrid = this.estadoincidencia;
        this.formNuevaprogramacion.value.estadopqrid = this.estadoincidencia ? this.estadoincidencia :'';
      }

      let listcoordinadores = new Array();
      for (let i in resp.data){
        if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid ==null){
          listcoordinadores.push(resp.data[i]);
        };
      }
      this.coordinadores = listcoordinadores;
    });
  }// .obtenerUsuariosTipo(tipo)

  datafecha(){
    this.fechaArray = [];
    if(this.agendaautomatica == '1'){
        this.fechaArray.push('1'.toString());
    }else{
        for (let index = 0; index < parseFloat(this.nuevaprogramacion.cantidad_inc); index++) {
            this.fechaArray.push(index.toString());
        }
    }
  }

  /**
   * Permite obtener la dependencia a la que pertenece un coordinador
   * JMM-2019-07-16
   */
  obtenerDependenciaCoordinador(){
    this.arrayAgregarTecnicos  = [];
    this.nuevaprogramacion.dependenciaid = '';
    for(let i in this.coordinadores){
      if(this.formNuevaprogramacion.value.coordinadorid == this.coordinadores[i].cedula){
        this.nuevaprogramacion.dependenciaid = this.coordinadores[i].dependenciaid != ''
                                  && this.coordinadores[i].dependenciaid != 'null'
                                  && this.coordinadores[i].dependenciaid != null
                                  ? this.coordinadores[i].dependenciaid
                                  : '';
      }
    }
  }

  getVersionEquipo(id){
    this._versiones.getversiondisponible(id).subscribe((resp)=>{
      if (resp.data) {
        this.versionesEquipo = resp.data;
      }
      $('.pqrarelacionar').val('').trigger('chosen:updated');
    });
  }

  /**
   * Permite enviar la petición a un servicio para crear el registro
   * JMM-2018-11-08
   */
  enviarCrear(fecha,fechafinal,horainicial,horafinal,nombretercero){
      if(this.servicio == '1' && this.primaestado == '1'){
        this.formNuevaprogramacion.value.estadopqrid = this.estadopqridCliente;
      }

      this.disabledBtnGuardar = true;
      let agendamiento = {
        //AGENDEAMIENTO
        'estado'              : 'A',//this.formNuevaprogramacion.value.estado,
        'clienteid'           : this.formNuevaprogramacion.value.terceroid,
        'sucursalid'          : this.formNuevaprogramacion.value.sucursalid,
        'contactoid'          : this.formNuevaprogramacion.value.contactoid,
        // 'versionid'           : this.formNuevaprogramacion.value.versionid,
        'coordinadorid'       : this.formNuevaprogramacion.value.coordinadorid,
        'presupuestoplaneado' : this.formNuevaprogramacion.value.presupuestoplaneado,
        //HEADPQR
        'ticket'              : this.formNuevaprogramacion.value.ticket,
        'terceroid'           : this.formNuevaprogramacion.value.terceroid,
        'equipoterceroid'     : this.formNuevaprogramacion.value.equipoterceroid,
        'asunto'              : this.formNuevaprogramacion.value.asunto,
        'descripcion'         : this.formNuevaprogramacion.value.descripcion,
        'tipopqrid'           : this.formNuevaprogramacion.value.tipopqrid,
        'tiposervicioid'      : this.formNuevaprogramacion.value.tiposervicioid,
        'usuario_creo'        : this.getUsuarioId,
        'prioridadid'         : this.formNuevaprogramacion.value.prioridadid,
        //FECHAAGENDA
        'fecha'               : fecha,
        'horainicial'         : horainicial,
        'horafinal'           : horafinal,
        'fechafinal'          : fechafinal,
        //AGENDAPQR
        'agendamientoid'      : '',
        'pqrid'               : '',
        //ALERTAPQR
        'asignado_a'          : this.formNuevaprogramacion.value.coordinadorid,
        'tipo'                : '1',
        //DETALLEPQR
        'estadopqrid'         : this.formNuevaprogramacion.value.estadopqrid,
        'esproveedor'         : this.formNuevaprogramacion.value.esproveedor == 1 ? this.formNuevaprogramacion.value.esproveedor : null,
        'estado_actualizado'  : 1,
        //TECNICOASIGNADOPQR
        'arraytecnicoid'      : this.formNuevaprogramacion.value.tecnicoagendamiento,
        'tipomantenimientoid' : '1',
        'colorhexadecimal'    : this.formNuevaprogramacion.value.colorhexadecimal,
        'actividadid'         : this.formNuevaprogramacion.value.actividadid,
        'operacionid'         : this.dataOpercionid,
        'versionid'           : this.dataVersionid,
        'valor_frecuencia'    : this.formNuevaprogramacion.value.valor_frecuencia,
        'unidad_medida'       : this.formNuevaprogramacion.value.unidad_medida,
        'cantidad_inc'        : this.formNuevaprogramacion.value.cantidad_inc,
        'dataEquipos'         : this.dataArryEquipo,
        'cambiaversionactual' : this.formNuevaprogramacion.value.cambiaversionactual,

        //Datos si tiene conexión en linea
        'incconelineaconta'   : this.incconelineaconta,
        'incconelineainven'   : this.incconelineainven,
        'servidorbdconta'     : this.servidorbdconta,
        'basedatosconta'      : this.basedatosconta,
        'usuarioconta'        : this.usuarioconta,
        'claveconta'          : this.claveconta,
        'servidorbdinven'     : this.servidorbdinven,
        'basedatosinven'      : this.basedatosinven,
        'usuarioinven'        : this.usuarioinven,
        'claveinven'          : this.claveinven,
        'tipoinventario'      : this.tipoinventario,
        'dependenciaid'       : this.nuevaprogramacion.dependenciaid,
        'visibilidad'         : this.nuevaprogramacion.visibilidad,
      }

      if(this.primaestado == '1'){
        swal({
            title: 'Señores ' + nombretercero + ' ('+this.observacionCliente+')',
            text: '',
            type: 'warning',
            showCancelButton  : true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor : '#d33',
            confirmButtonText : 'Aceptar',
            cancelButtonText  : 'Cancelar'
          }).then((result) => {
            if (result.value) {
              this.enviarsetAgendamiento(agendamiento);
            }else{
              this.disabledBtnGuardar = false;
            }
          });
      }else{
        this.enviarsetAgendamiento(agendamiento);
      }
  }// enviarCrear()

  enviarsetAgendamiento(agendamiento){
    if (this.dataArryEquipo.length > 0) {
      //GUARDA DATOS DEL AGENDAMIENTO
      this._agendamiento.setAgendamiento(agendamiento).subscribe((resp)=>{
          let pqrid_rastreo = resp.data;
          this.disabledBtnGuardar = false;
          if (resp.error) {
            this.disabledBtnGuardar = false;
            if (resp.data.errorInfo) {
              this.toastr.error(resp.data.errorInfo[2], 'Error', { timeOut: 3000 });
            }else{
              this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
            }
          }else {
            //Rastreo
            let opcionEnviar = 'Asigna Agendamiento al Cliente: '+ agendamiento.clienteid + '  Pqr : ' + pqrid_rastreo ;
            this._rastreo.setRastreo(opcionEnviar,'Agendamiento').subscribe((resp)=>{
            });//fin rastreo
            this.disabledBtnGuardar = false;
            this.toastr.success('Datos guardados exitosamente', '', { timeOut: 3000 });
            this.modalRef.hide();
            this.router.navigate(['/main/enrutamientos/enrutamiento', 'agendamientoapp'], { replaceUrl: true });
          }
      });
    }else{
      this.toastr.error('Debe seleccionar al menos un Equipo de la lista', 'Error', { timeOut: 3000 });
      this.disabledBtnGuardar = false;
    }
  }

  /**
   * Permite enviar la petición a un servicio para modificar el registro
   * JMM-2018-11-13
   */
  enviarModificar(agendamientoid,fecha,fechafinal,horainicial,horafinal){
    var selected = [];
    $("input[data-checkbox=checkbox_1]").each(function(){
        let itemequipo_aux = $(this).val() ? $(this).val().split("-") : '';
        let itemequipoid = itemequipo_aux[1] ? itemequipo_aux[1].trim() : '';
        let actividadid = itemequipo_aux[0] ? itemequipo_aux[0].trim() : '';
        if ($(this).is(":checked")){
            selected.push({
              'actividadid'      :   actividadid,
              'pqrid'            :   '',
              'esactividadpqr'  :    '1',
            });
        } else {
            selected.push({
              'actividadid'     :   actividadid,
              'pqrid'           :   '',
              'esactividadpqr' :    '0',
            });
        }
    });

   this.formNuevaprogramacion.value.actividadid = selected;
    let agendamiento = {
      //AGENDEAMIENTO
      'estado'              : 'A', //this.formNuevaprogramacion.value.estado,
      'clienteid'           : this.formNuevaprogramacion.value.terceroid,
      'sucursalid'          : this.formNuevaprogramacion.value.sucursalid,
      'contactoid'          : this.formNuevaprogramacion.value.contactoid,
      'versionid'           : this.validaversion == true ? this.formNuevaprogramacion.value.versionid : '',
      'coordinadorid'       : this.formNuevaprogramacion.value.coordinadorid,
      'colorhexadecimal'    : this.formNuevaprogramacion.value.colorhexadecimal,
      //HEADPQR
      'ticket'              : this.formNuevaprogramacion.value.ticket,
      'terceroid'           : this.formNuevaprogramacion.value.terceroid,
      'equipoterceroid'     : this.formNuevaprogramacion.value.equipoterceroid,
      'asunto'              : this.formNuevaprogramacion.value.asunto,
      'descripcion'         : this.formNuevaprogramacion.value.descripcion,
      'tipopqrid'           : this.formNuevaprogramacion.value.tipopqrid,
      'tiposervicioid'      : this.formNuevaprogramacion.value.tiposervicioid,
      'usuario_creo'        : this.getUsuarioId,
      'prioridadid'         : this.formNuevaprogramacion.value.prioridadid,
      //FECHAAGENDA
      'fecha'               : fecha[0]['fecha'],
      'horainicial'         : horainicial[0]['horainicial'],
      'horafinal'           : horafinal[0]['horafinal'],
      'fechafinal'          : fechafinal[0]['fechafinal'],
      //AGENDAPQR
      'fechaagendaid'       : this.formNuevaprogramacion.value.fechaagendaid,
      'agendamientoid'      : this.formNuevaprogramacion.value.agendamientoid,
      'presupuestoplaneado' : this.formNuevaprogramacion.value.presupuestoplaneado,
      'pqrid'               : this.formNuevaprogramacion.value.pqrid,
      //ALERTAPQR
      'alertapqrid'         : this.formNuevaprogramacion.value.alertapqrid,
      'asignado_a'          : this.formNuevaprogramacion.value.coordinadorid,
      'tipo'                : '1',
      //DETALLEPQR
      'estadopqrid'         : this.formNuevaprogramacion.value.estadopqrid,
      'esproveedor'         : this.formNuevaprogramacion.value.esproveedor == 1 ?  this.formNuevaprogramacion.value.esproveedor : null,
      'detallepqrid'        : this.formNuevaprogramacion.value.detallepqrid,
      'estado_actualizado'  : 1,
      //TECNICOASIGNADOPQR
      'arraytecnicoid'      : this.formNuevaprogramacion.value.tecnicoagendamiento,
      'actividadid'         : this.formNuevaprogramacion.value.actividadid,
      'operacionid'         : this.formNuevaprogramacion.value.operacionid,
      'dependenciaid'       : this.nuevaprogramacion.dependenciaid,
      'cambiaversionactual' : this.formNuevaprogramacion.value.cambiaversionactual,

      //Datos si tiene conexión en linea
      'incconelineaconta'   : this.incconelineaconta,
      'incconelineainven'   : this.incconelineainven,
      'servidorbdconta'     : this.servidorbdconta,
      'basedatosconta'      : this.basedatosconta,
      'usuarioconta'        : this.usuarioconta,
      'claveconta'          : this.claveconta,
      'servidorbdinven'     : this.servidorbdinven,
      'basedatosinven'      : this.basedatosinven,
      'usuarioinven'        : this.usuarioinven,
      'claveinven'          : this.claveinven,
      'tipoinventario'      : this.tipoinventario,
      'visibilidad'         : this.formNuevaprogramacion.value.visibilidad,
    }
    //GUARDA DATOS DE LA PQR

    this._agendamiento.editAgendamiento(agendamiento).subscribe((resp)=>{
      if (resp.error) {
        this.disabledBtnGuardar = false;
        this.toastr.error(this.mensajeError, 'Error', { timeOut: 3000 });
      }
      else {
        //Rastreo
        if(this.nuevaprogramacion.fecha_aux != agendamiento.fecha[0]['fecha']){
          let opcionEnviar =
          'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
          ' Cambia Fecha Inicial: '+ this.nuevaprogramacion.fecha_aux +
          ' -> Despues: '+ agendamiento.fecha[0]['fecha'];
          this.rastreo(opcionEnviar);
        }
        if(this.nuevaprogramacion.fechafinal_aux != agendamiento.fechafinal[0]['fechafinal']){
          let opcionEnviar =
          'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
          ' Cambia Fecha Final: '+ this.nuevaprogramacion.fechafinal_aux +
          ' -> Despues: '+ fechafinal[0]['fechafinal'];
          this.rastreo(opcionEnviar);
        }
        if(this.nuevaprogramacion.horainicial_aux != agendamiento.horainicial[0]['horainicial']){
          let opcionEnviar =
          'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
          ' Cambia Hora Inicial: '+ this.nuevaprogramacion.horainicial_aux +
          ' -> Despues: '+ agendamiento.horainicial[0]['horainicial'];
          this.rastreo(opcionEnviar);
        }
        if(this.nuevaprogramacion.horafinal_aux != agendamiento.horafinal[0]['horafinal']){
          let opcionEnviar =
          'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
          ' Cambia Hora Finial: '+ this.nuevaprogramacion.horafinal_aux +
          ' -> Despues: '+ agendamiento.horafinal[0]['horafinal'];
          this.rastreo(opcionEnviar);
        }
        if(this.nuevaprogramacion.estado_aux != agendamiento.estado){
          this.nuevaprogramacion.estado_aux = (this.nuevaprogramacion.estado_aux =='A') ? 'ACTIVO' : 'INACTIVO';
          agendamiento.estado = (agendamiento.estado == 'A') ? 'ACTIVO' : 'INACTIVO';

          let opcionEnviar =
          'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
          ' Cambia Estado Calendario: '+ this.nuevaprogramacion.estado_aux +
          ' -> Despues: '+ agendamiento.estado;
          this.rastreo(opcionEnviar);
        }

        if(this.nuevaprogramacion.tipopqrid_aux != agendamiento.tipopqrid){
          if(this.nuevaprogramacion.tipopqrid_aux == '1'){
            this.nuevaprogramacion.tipopqrid_aux = 'RECLAMO';
          }
          if(agendamiento.tipopqrid == '1'){
            agendamiento.tipopqrid = 'RECLAMO';
          }
          if(this.nuevaprogramacion.tipopqrid_aux == '2'){
            this.nuevaprogramacion.tipopqrid_aux = 'ARREGLO';
          }
          if(agendamiento.tipopqrid == '2'){
            agendamiento.tipopqrid = 'ARREGLO';
          }
          if(this.nuevaprogramacion.tipopqrid_aux == '3'){
            this.nuevaprogramacion.tipopqrid_aux = 'GARANTIA';
          }
          if(agendamiento.tipopqrid == '3'){
            agendamiento.tipopqrid = 'GARANTIA';
          }
          if(this.nuevaprogramacion.tipopqrid_aux == '4'){
            this.nuevaprogramacion.tipopqrid_aux = 'SUGERENCIA';
          }
          if(agendamiento.tipopqrid == '4'){
            agendamiento.tipopqrid = 'SUGERENCIA';
          }
          if(this.nuevaprogramacion.tipopqrid_aux == '5'){
            this.nuevaprogramacion.tipopqrid_aux = 'QUEJA';
          }
          if(agendamiento.tipopqrid == '5'){
            agendamiento.tipopqrid = 'QUEJA';
          }
          if(this.nuevaprogramacion.tipopqrid_aux == '6'){
            this.nuevaprogramacion.tipopqrid_aux = 'PETICION';
          }
          if(agendamiento.tipopqrid == '6'){
            agendamiento.tipopqrid = 'PETICION';
          }
          let opcionEnviar =
          'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
          ' Cambia Tipo Incidencia: '+ this.nuevaprogramacion.tipopqrid_aux +
          ' -> Despues: '+ agendamiento.tipopqrid;
          this.rastreo(opcionEnviar);
        }
        if(this.nuevaprogramacion.estadopqrid_aux != agendamiento.estadopqrid){
          for (let i in this.estadosnombreArray){
            if(this.estadosnombreArray[i].id == agendamiento.estadopqrid){
              let agendamientoestado = this.estadosnombreArray[i].nombre
              let opcionEnviar =
              'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
              ' Cambia Estado INC: '+ this.nuevaprogramacion.estadopqrid_aux + ' '+ this.nuevaprogramacion.estadopqridnombre_aux +
              ' -> Despues: '+ agendamiento.estadopqrid +' '+ agendamientoestado;
              this.rastreo(opcionEnviar);
            }
          }
        }
        if(this.nuevaprogramacion.tiposervicioid_aux != agendamiento.tiposervicioid){
          for(let i in this.serviciosArray){
            if(this.serviciosArray[i].id == agendamiento.tiposervicioid){
              let agendamientoservicio = this.serviciosArray[i].nombre;
              let opcionEnviar =
              'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
              ' Cambia Tipo Servicio: '+ this.nuevaprogramacion.tiposervicioid_aux +' '+ this.nuevaprogramacion.servicionombre +
              ' -> Despues: '+ agendamiento.tiposervicioid +' '+ agendamientoservicio;
              this.rastreo(opcionEnviar);
            }
          }
        }
        if(this.nuevaprogramacion.terceroid_aux != agendamiento.clienteid){
          for(let i in this.clienteArray){
            if(this.clienteArray[i].terceroid == agendamiento.terceroid){
              let agendamientocliente = this.clienteArray[i].nombre;
              let opcionEnviar =
              'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
              ' Cambia Cliente: '+ this.nuevaprogramacion.terceroid_aux +' '+ this.nuevaprogramacion.nombrecliente +
              ' -> Despues: '+ agendamiento.clienteid+' '+ agendamientocliente;
              this.rastreo(opcionEnviar);
            }
          }
        }
        if(this.nuevaprogramacion.equipoterceroid_aux != agendamiento.equipoterceroid){
          for(let i in this.equipoArray){
            if(this.equipoArray[i].equipoterceroid == agendamiento.equipoterceroid){
              let agendamientoequipo = this.equipoArray[i].nombreequipo;
              let opcionEnviar =
              'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
              ' Cambia Equipo: '+ this.nuevaprogramacion.equipoterceroid_aux +' '+ this.nuevaprogramacion.nombreequipo +
              ' -> Despues: '+ agendamiento.equipoterceroid +' '+ agendamientoequipo;
              this.rastreo(opcionEnviar);
            }
          }
        }

        if(this.nuevaprogramacion.sucursalid_aux != agendamiento.sucursalid){
          for(let i in this.sucursalArray){
            if(this.sucursalArray[i].sucursalid == agendamiento.sucursalid){
              let agendamientosucursal = this.sucursalArray[i].nombre
              let opcionEnviar =
              'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
              ' Cambia Sucursal: '+ this.nuevaprogramacion.sucursalid_aux  +
              ' -> Despues: '+ agendamiento.sucursalid +' '+ agendamientosucursal;
              this.rastreo(opcionEnviar);
            }
          }
          if(agendamiento.sucursalid == ''){
            let opcionEnviar =
            'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
            ' Cambia Sucursal: '+ this.nuevaprogramacion.sucursalid_aux +' '+ this.nuevaprogramacion.nombresucursal +
            ' -> Despues: '+ agendamiento.sucursalid;
            this.rastreo(opcionEnviar);
          }
        }
        if(this.nuevaprogramacion.coordinadorid_aux != agendamiento.coordinadorid){
          for(let i in this.coordinadorArray){
            if(this.coordinadorArray[i].cedula == agendamiento.coordinadorid){
              let agendamientocoordinador = this.coordinadorArray[i].nombreusuario;
              let opcionEnviar =
              'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
              ' Cambia Coordinador: '+ this.nuevaprogramacion.coordinadorid_aux +' '+ this.nuevaprogramacion.nombrecoordinador +
              ' -> Despues: '+ agendamiento.coordinadorid +' '+ agendamientocoordinador;
              this.rastreo(opcionEnviar);
            }
          }
        }

        if(this.nuevaprogramacion.presupuestoplaneado_aux != agendamiento.presupuestoplaneado){
          let opcionEnviar =
          'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
          ' Presupuesto Planeado: '+ this.nuevaprogramacion.presupuestoplaneado_aux +
          ' -> Despues: '+ agendamiento.presupuestoplaneado;
          this.rastreo(opcionEnviar);
        }

        if(this.nuevaprogramacion.colorhexadecimal_aux != agendamiento.colorhexadecimal){
          let opcionEnviar =
          'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
          ' Cambia Color: '+ this.nuevaprogramacion.colorhexadecimal_aux +
          ' -> Despues: '+ agendamiento.colorhexadecimal;
          this.rastreo(opcionEnviar);
        }
        if(this.nuevaprogramacion.prioridadid_aux != agendamiento.prioridadid){
          if(this.nuevaprogramacion.prioridadid_aux == '1'){
            this.nuevaprogramacion.prioridadid_aux = 'ALTA';
          }
          if(agendamiento.prioridadid == '1'){
            agendamiento.prioridadid = 'ALTA';
          }
          if(this.nuevaprogramacion.prioridadid_aux == '2'){
            this.nuevaprogramacion.prioridadid_aux = 'MEDIA';
          }
          if(agendamiento.prioridadid == '2'){
            agendamiento.prioridadid = 'MEDIA';
          }
          if(this.nuevaprogramacion.prioridadid_aux == '3'){
            this.nuevaprogramacion.prioridadid_aux = 'BAJA';
          }
          if(agendamiento.prioridadid == '3'){
            agendamiento.prioridadid = 'BAJA';
          }
          let opcionEnviar =
          'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid +
          ' Cambia Prioridad: '+ this.nuevaprogramacion.prioridadid_aux +
          ' -> Despues: '+ agendamiento.prioridadid;
          this.rastreo(opcionEnviar);
        }
        if(this.nuevaprogramacion.asunto_aux != agendamiento.asunto){
          let opcionEnviar =
          'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
          ' Cambia Asunto: '+ this.nuevaprogramacion.asunto_aux +
          ' -> Despues: '+ agendamiento.asunto;
          this.rastreo(opcionEnviar);
        }
        if(this.nuevaprogramacion.descripcion_aux != agendamiento.descripcion){
          let opcionEnviar =
          'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
          ' Cambia Descripcion: '+ this.nuevaprogramacion.descripcion_aux +
          ' -> Despues: '+ agendamiento.descripcion;
          this.rastreo(opcionEnviar);
        }
        /**
         * Esta funcionalidad permite sacar el id y el nombre de los tecnicos, del cambio entrante
         * JULIAN CANDAMIL
         */
        this.Tecnicoslist = [];
        for(let i in agendamiento.arraytecnicoid){
          for(let j in this.listatecnicossegur){
            if(agendamiento.arraytecnicoid[i] == this.listatecnicossegur[j].cedula){
              this.Tecnicoslist.push(this.listatecnicossegur[j].cedula + ' => ' + this.listatecnicossegur[j].nombreusuario);
            }
          }
        }

        /**
         * Esta funcionalidad permite mandar al rastreo si viene tecnicos
         * JULIAN CANDAMIL
         */
        if(agendamiento.arraytecnicoid.length != this.tecnicoagendamientoArray_aux.length){
          let opcionEnviar =
          'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
          ' Cambia Tecnicos: '+ this.TecnicoList +
          ' -> Despues: '+ this.Tecnicoslist;
          this.rastreo(opcionEnviar);
        }else{
          let diferente = 0;
          for (let i in this.tecnicoagendamientoArray_aux) {
            let contador = 0;
            for (let j in agendamiento.arraytecnicoid) {
              if(this.tecnicoagendamientoArray_aux[i] != agendamiento.arraytecnicoid[j]){
                contador = contador + 1;
              }
            }
            if (agendamiento.arraytecnicoid.length == contador ){
              diferente = diferente + 1;
            }
          }
          if(diferente > 0){
            let opcionEnviar =
            'Modifica Agendamiento: INC: '+ this.nuevaprogramacion.pqrid_aux +
            ' Cambia Tecnicos: '+ this.TecnicoList +
            ' -> Despues: '+ this.Tecnicoslist;
            this.rastreo(opcionEnviar);
          }
        }
        this.disabledBtnGuardar = false;
        this.toastr.success('Datos actualizados exitosamente', '', { timeOut: 3000 });
        this.modalRef.hide();
        this.router.navigate(['/main/enrutamientos/enrutamiento', 'agendamientoapp'], { replaceUrl: true });
      }
    });
  }// enviaModificar()

  /**
  * Permite enviar el rastreo al servicio
  *
  */
  rastreo(opcionEnviar){
    this._rastreo.setRastreo(opcionEnviar, 'Agendamiento').subscribe((resp)=>{
    });
  }

  /**
   * Formulario para los filtros de busqueda
   * JMM-2018-11-07
  */
  filtrosformulario(){
    this.formFiltros = new FormGroup({
      'fecha_de_creacion_inc' : new FormControl(this.filtros.fecha_de_creacion_inc),
      'fecha_final'           : new FormControl(this.filtros.fecha_final),
      'nombre_tecnico'        : new FormControl(this.filtros.nombre_tecnico)
    });
  }// .filtrosformulario()

    /**
   * Permite habilitar y consultar los tipos de actividades
   * CAAA-2018-11-26
   */
  habilitarCampoTipoActividad(pqrid){
    this._pqr.obtenerTipoActividades(pqrid).subscribe((resp)=>{
      this.listaTipoActividad = resp.data;
    });
  }

  /**
   * Función para obtener el listado de tecnicos asignados
   * JMM-2018-07-13
   */
  obtenerTecnicosAsignadosPqr(detallepqrid){
    this.detallepqriid = detallepqrid;
    this.tecnicosCierre = [];
    this.mostrarBotonRefreshCierreActividad = false;
    this.mostrarBotonRefresh = false;

    this._tecnicoasignadopqr.getTecnicoAsignadoPqr(detallepqrid).subscribe((res)=>{
      this.tapqrArray  = res.data;
      this.cantidadcamposasignados = res.data.length; //Variable para almacenar la cantidad de campos de los tecnicos asignados

       this._pqr.listActividadesTecnicosLogtiempo(this.nuevaprogramacion.pqrid).subscribe((resp)=>{
        if (this.usuarioCliente ==1) {
          $('select').prop('disabled',true);
          $('#tecnicodt').prop('disabled',true);
        }
        for (let i in this.tapqrArray){
          for (let j in resp.data){
            if (resp.data[j].usuarioinicio == this.tapqrArray[i].tecnicoid){
              //FORMATO DE FECHAS
              var fechainicial;
              var horainicial;
              if (resp.data[j].inicio != null) {
                fechainicial = (resp.data[j].inicio.substring(0,resp.data[j].inicio.length-9)).replace(/^(\d{2})-(\d{2})-(\d{4})$/g,'$3-$2-$1');
                horainicial =  resp.data[j].inicio.substring(11,resp.data[j].inicio.length-3) == '00:00' ? '00:00' : resp.data[j].inicio.substring(11,resp.data[j].inicio.length-3);
              }else{
                fechainicial = '0001-01-01';
                horainicial = ''
              }

              var fechafinal;
              var horafinal;
              if (resp.data[j].fin != null) {
                fechafinal =(resp.data[j].fin.substring(0,resp.data[j].fin.length-9)).replace(/^(\d{2})-(\d{2})-(\d{4})$/g,'$3-$2-$1');
                horafinal = resp.data[j].fin.substring(11,resp.data[j].fin.length-3) == '00:00' ? '00:00' : resp.data[j].fin.substring(11,resp.data[j].fin.length-3);
              }else{
                fechafinal = '0001-01-01';
                horafinal = ''
              }

              this.tecnicosCierre.push({
                'logtiempoinico'    : resp.data[j].logtiempoinico ? resp.data[j].logtiempoinico : '',
                'logtiempofin'      : resp.data[j].logtiempofin ? resp.data[j].logtiempofin : '',
                'tecnicoid'         : resp.data[j].usuarioinicio ? resp.data[j].usuarioinicio : '',
                'nombretecnico'     : resp.data[j].nombreusuarioinicio ? resp.data[j].nombreusuarioinicio : '',
                'tipoactividadid'   : resp.data[j].tipoactividadid ? resp.data[j].tipoactividadid : '',
                'nombreactividad'   : resp.data[j].nombre ? resp.data[j].nombre : '',
                'fechainicial'      : fechainicial == '0001-01-01' ? '' : fechainicial,
                'horainicial'       : horainicial,
                'fechafinal'        : fechafinal == '0001-01-01' ? '' : fechafinal,
                'horafinal'         : horafinal,
                'iniciada'          : fechainicial > '0001-01-01' ? '1' : '',
                'bloquearactividad' : resp.data[j].tipoactividadid ? 'true' : 'false',
                'bloqueariniciar'   : fechainicial > '0001-01-01' ? 'true' : 'false',
                'bloquearfinalizar' : fechafinal > '0001-01-01' ? 'true' : 'false',
                'detallepqrid'      :resp.data[j].detallepqrid ? resp.data[j].detallepqrid : '',
              });
            }// .if
          }// .for

          this.tecnicosCierre.push({
            'logtiempoinico'    : '',
            'logtiempofin'      : '',
            'tecnicoid'         : this.tapqrArray[i].tecnicoid,
            'nombretecnico'     : this.tapqrArray[i].nombretecnico,
            'tipoactividadid'   : '',
            'nombreactividad'   : '',
            'fechainicial'      : '',
            'horainicial'       : '',
            'fechafinal'        : '',
            'horafinal'         : '',
            'iniciada'          : '',
            'bloquearactividad' : 'false',
            'bloqueariniciar'   : 'false',
            'bloquearfinalizar' : 'false'
          });
        }// .for
      });
    });
  }

   /**
   * Permite enviar la petición para cerrar los incidencias con actividades iniciadas
   * CAAA-2018-11-29
   */
  CerrararActividad(){
    let vampo_vacio = 0; //variable que define el contenido del campo, si es vacio=1, si es lleno=0
    var cantidadinputs1;
    var cantidadinputs2;

    //Arreglo de datos dinamicos
    let arregloDatosTecnicos1 = new Array;

    let arregloDatosTecnicos_aux = new Array;
    let arregloDatosTecnicos = new Array;
    let totalArryayActividadesCierre = new Array();

    cantidadinputs1 = $('#cantidadcampos').val();
    cantidadinputs2 = $('#cantidadcamposCierreActividad').val();

    for (var i = 0; i <= cantidadinputs2; i ++){
      if ($('#formatofinal_'+i).val() == undefined){
        //validacion de campos requeridos en el cierre de las actividades
        if ($('#tecnicoidasignadoCierre_'+i).val() == '') {
          this.toastr.warning('Debe digitar tecnicoidasignado', '', { timeOut: 3000 });
          vampo_vacio = vampo_vacio + 1;
        }
        else if (this.nuevaprogramacion.pqrid == '') {
          this.toastr.warning('Por favor espere que la incidencia cargue toda la información', '', { timeOut: 3000 });
          vampo_vacio = vampo_vacio + 1;
        }

        if ($('#fechainicialCierre_'+i).val() =='') {
          let alerta_div_fecha_inicial_ = (
            '<div class="alert alert-danger" style="padding: 5px;">El campo es requerido</div>'
          );
          $('#alerta_div_fecha_inicial_'+i).html(alerta_div_fecha_inicial_);
          vampo_vacio = vampo_vacio + 1;
        }
        else {
          $('#alerta_div_fecha_inicial_'+i).html("");
        }

        if ($('#fechafinalCierre_'+i).val() == '') {
          let alerta_div_fecha_final_ = (
            '<div class="alert alert-danger" style="padding: 5px;">El campo es requerido</div>'
          );
          $('#alerta_div_fecha_final_'+i).html(alerta_div_fecha_final_);
          vampo_vacio = vampo_vacio + 1;
        }
        else {
          $('#alerta_div_fecha_final_'+i).html("");
        }

        if ($('#horafinal_'+i).val() == '') {
          let alerta_div_horafinal_ = (
            '<div class="alert alert-danger" style="padding: 5px;">El campo es requerido</div>'
          );
          $('#alerta_div_horafinal_'+i).html(alerta_div_horafinal_);
          vampo_vacio = vampo_vacio + 1;
        }
        else {
          $('#alerta_div_horafinal_'+i).html("");
        }

        if ($('#hora_Inicial_'+i).val() == '') {
          let alerta_div_hora_Inicial_ = (
            '<div class="alert alert-danger" style="padding: 5px;">El campo es requerido</div>'
          );
          $('#alerta_div_hora_Inicial_'+i).html(alerta_div_hora_Inicial_);
          vampo_vacio = vampo_vacio + 1;
        }
        else{
          $('#alerta_div_hora_Inicial_'+i).html("");
        }

        if ($('#actividadCierre_'+i).val() == '') {
          let alerta_div_actividadCierre_ = (
            '<div class="alert alert-danger" style="padding: 5px;">El campo es requerido</div>'
          );
          $('#alerta_div_actividadCierre_'+i).html(alerta_div_actividadCierre_);
          vampo_vacio = vampo_vacio + 1;
        }
        else {
          $('#alerta_div_actividadCierre_'+i).html("");
        }

        if ($('#fechainicialCierre_'+i).val() > $('#fechafinalCierre_'+i).val()) {
          let alerta_div_fecha_final_mayor_ = (
            '<div class="alert alert-danger" style="padding: 5px;">La fecha Final debe ser igual o mayor a la fecha Inicial</div>'
          );
          if ($('#fechafinalCierre_'+i).val() != '') {
            $('#alerta_div_fecha_final_mayor_'+i).html(alerta_div_fecha_final_mayor_);
            $('#alerta_div_fecha_final_'+i).html("");
          }
          vampo_vacio = vampo_vacio + 1;
        }

        if ($('#fechainicialCierre_'+i).val() == $('#fechafinalCierre_'+i).val()) {

          if ($('#hora_Inicial_'+i).val() > $('#horafinal_'+i).val()) {
            let alerta_div_fecha_final_mayor_ = (
              '<div class="alert alert-danger" style="padding: 5px;">La hora Final debe ser  mayor a la hora Inicial</div>'
            );

            $('#alerta_div_fecha_final_mayor_'+i).html(alerta_div_fecha_final_mayor_);
            $('#alerta_div_fecha_final_'+i).html("");
            vampo_vacio = vampo_vacio + 1;
          }else{
            $('#alerta_div_fecha_final_mayor_'+i).html("");
          }
        }

        else {
          $('#alerta_div_fecha_final_mayor_'+i).html("");
          vampo_vacio = 0;
        }
        //Fin de validacion de campos requeridos en el cierre de las actividades

        //si vampo_vacio==0, quiere decir que todos los campos estan diligenciados
        if (vampo_vacio == 0){
          let arregloDatosTecnicos2 = new Array;

          //valida los campos que no esten bloqueados y que se encuentren diligenciados
          if ($('#bloquearfinalizar_'+i).val() == 'false' && vampo_vacio == 0){
            //FORMATO DE FECHAS
            var fechainicial;
            var fechainicial_aux;
            fechainicial = $('#fechainicialCierre_'+i).val().replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3-$2-$1');
            fechainicial_aux = fechainicial.split('-');
            fechainicial = fechainicial_aux[2]+'-'+fechainicial_aux[1]+'-'+fechainicial_aux[0];

            var fechafinal;
            var fechafinal_aux;
            fechafinal = $('#fechafinalCierre_'+i).val().replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3-$2-$1');
            fechafinal_aux = fechafinal.split('-');
            fechafinal = fechafinal_aux[2]+'-'+fechafinal_aux[1]+'-'+fechafinal_aux[0];

            let objetoDatosTecnicos = {
              'tecnicoid'       : $('#tecnicoCierre_'+i).val(),
              'pqrid'           : this.nuevaprogramacion.pqrid,
              'fechainicial'    : fechainicial,
              'horaInicial'     : $('#hora_Inicialt_'+i).val(),
              'formatoinicial'  : $('#formatoinicial_'+i).val(),
              'fechafinal'      : fechafinal,
              'horaFinal'       : $('#horafinalt_'+i).val(),
              'actividad'       : $('#actividadCierre_'+i).val(),
              'iniciada'        : $('#iniciada_'+i).val(),
              'formatofinal'    : $('#formatofinal_'+i).val(),
            };
            arregloDatosTecnicos2.push(objetoDatosTecnicos);
            totalArryayActividadesCierre.push(arregloDatosTecnicos2[0]);
          }
        }
      }
    }

    //valida nuevamente que los campos esten diligenciados
    if (vampo_vacio == 0){
      let obj_ActividadesCierre= {
        'data_ActividadesCierre' : totalArryayActividadesCierre,
      }

      /**
       * Permite enviar la petición para guardar los datos de cierre de actividades
       * CAAA-2019-01-10
       */
      this._pqr.cerrarActividadPqrWeb(obj_ActividadesCierre).subscribe((resp)=>{

        if (resp.error) {
          this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
        }else {
          this.toastr.success(resp.message, '', { timeOut: 3000 });
          this.tecnicosCierre = [];
          this.tapqrArray = [];
          this.obtenerDetallesPqr(this.nuevaprogramacion.pqrid);
        }
      });
    }
  }

   /**
   * Función para obtener el historial de estados de una PQR
   * JMM-2018-07-13
   */
  obtenerDetallesPqr(pqrid){
    this.disabledCierreCactividad = false;
    this._tratamientopqr.getDetallesPqr(pqrid).subscribe((resp)=>{
      if (resp.data){
        this.dtpqrArray = resp.data;
        this.id_detallepqr = resp.data[0].id;
        //Obtener el coordinador asignado actual, obtener el id del detalle actual
        for (let repdata of resp.data) {
          if (repdata.estado_actualizado == 1) {
            if (repdata.cumplido == '1' || repdata.cumplido == '0') {
              this.detallepqr.cumplido = repdata.cumplido;
              this.cumplida = true;
            } else if (repdata.cumplido == '') {
              this.detallepqr.cumplido = '';
              this.cumplida = false;
            }
          }
        }
        //Obtener listado de tecnicos asignados
        this.obtenerTecnicosAsignadosPqr(this.id_detallepqr);
      }
    });
  }// .obtenerDetallesPqr(pqrid)

    /**
   * Permite enviar la petición a un servicio para eliminar el registro
   * CESAR ARIAS-2019-04-02
   */
  validaUasuarioAutorizador($accion,$file,$param1,$param2){
    this.dataAutorizo = '';
    if (this.getUsuarioId == 'prosof') {
      if ($accion == 'Editar') {
        this.editActividad($file,$param1,$param2);
      }else if ($accion == 'Eliminar'){
        this.eliminarActividad($file,$param1,$param2,null);
      }
    }else{
        swal({
          title: 'Digite Usuario y contraseña coordinador',
          html:
            '<input type="text" id="coordinadorAutoriza_id" placeholder="Usuario..." class="swal2-input" autocomplete="off">'+
            '<input type="password" id="paswwordcoordinadorAutoriza_id" placeholder="password..." class="swal2-input" autocomplete="off">',
          text: "",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.value) {
            let usuarioValidar = {
              'usuarioid' : $('#coordinadorAutoriza_id').val(),
              'clave'  : $('#paswwordcoordinadorAutoriza_id').val()
            }
            this._pqr.validaUasuarioAutorizador(usuarioValidar).subscribe((resp)=>{
              if (resp.data.length > 0) {
                //datos para el rastreo de la persona que autorizo el la accion
                 this.dataAutorizo = {
                   'nombre'    : resp.data[0]['nombre'],
                   'usuarioid' : resp.data[0]['usuarioid'],
                   'cedula'    : resp.data[0]['cedula'],
                 }
                this._perfiles.getPermisos(resp.data[0]['usuarioid'],resp.data[0]['perfilid']).subscribe((resp)=>{
                  let listpermisosAutoriza = this._perfiles.getObjectPermisosUsuarios(resp.data);
                  if(listpermisosAutoriza.autorizar_gestion_atctividades_de_agendamiento == true){
                    if($accion == 'Editar'){
                      this.editActividad($file,$param1,$param2);
                    }else if ($accion == 'Eliminar'){
                      this.eliminarActividad($file,$param1,$param2,this.dataAutorizo);
                    }
                  }else{
                    this.toastr.warning('el cordinador no tiene permisos para autorizar la acción', '', { timeOut: 3000 });
                  }
                });
              }else{
                this.toastr.warning('Por favor digite una clve o contraseña correcta', '', { timeOut: 3000 });
              }
            });
          }
        });
      }
  }

  editActividad(j,bloqueariniciar,bloquearfinalizar){
    $('#actividadCierre_'+j).val() != '' ?  $('#actividadCierre_'+j).removeAttr('disabled', false) : '';
    $('#cerrarActividad').prop('disabled',true);

    if(bloqueariniciar == 'true'){
      $('#fechainicialCierre_'+j).removeAttr('disabled', false);
      $('.hora_Inicial_'+j).removeAttr('disabled', false);
    }else{
      $('#fechainicialCierre_'+j).prop('disabled', true).val('');
      $('#hora_Inicial_'+j).prop('disabled', true).val('');
    }
    if (bloquearfinalizar == 'true') {
       $('#fechafinalCierre_'+j).removeAttr('disabled', false);
       $('.horafinal_'+j).removeAttr('disabled', false);
    }else{
      $('#fechafinalCierre_'+j).prop('disabled', true).val('');
      $('#horafinal_'+j).prop('disabled', true).val('');
    }

    $('#btneditActividad_'+j).addClass('hidden');
    $("#btnsubmitEdit_"+j).removeClass('hidden');
  }

   /**
   * Permite enviar la petición a un servicio para eliminar el registro
   * CESAR ARIAS-2019-04-02
   */
  eliminarActividad(j,logtiempoinico,logtiempofin,$dataAutorizo){
    swal({
      title: 'Esta seguro de eliminar el registro?',
      text: "",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        let dataeliminar = {
          'logtiempoinico' : logtiempoinico,
          'logtiempofin'   : logtiempofin,
          'dataAutorizo'   : $dataAutorizo
        }
        this._pqr.eliminarActividad(dataeliminar).subscribe((resp)=>{
         if (resp.error) {
              this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
              $("#btneditActividad_"+j).removeClass('hidden');
              $('#btnsubmitEdit_'+j).addClass('hidden');
            }// .if
            else {
              this.toastr.success(resp.message, '', { timeOut: 3000 });
              this.tecnicosCierre = [];
              this.tapqrArray = [];
              this.obtenerDetallesPqr(this.nuevaprogramacion.pqrid);
            }// .else
       });
      }
   });
  }

  submitEdit(j,bloqueariniciar,bloquearfinalizar){
    let validadorcampo = '<div class="alert alert-danger" style="padding: 5px;">El campo es requerido</div>';
    let campo_vacio = 0;
    let actividadCierre     = $('#actividadCierre_'+j).val();
    let logtiempoinicio     = $('#logtiempoinico_'+j).val();
    let logtiempocierre     = $('#logtiempofin_'+j).val();
    let fechainicialCierre  = $('#fechainicialCierre_'+j).val();
    let hora_inicio         = $('.hora_Inicial_'+j).val();
    let fechafinalcierre    = $('#fechafinalCierre_'+j).val();
    let horafinal           = $('.horafinal_'+j).val();

    //validacion de campos requeridos en el cierre de las actividades
    if ($('#tecnicoidasignadoCierre_'+j).val() == '') {
      this.toastr.warning('Debe digitar tecnicoidasignado', '', { timeOut: 3000 });
      campo_vacio  = campo_vacio = + 1;

    }
    else if (this.nuevaprogramacion.pqrid == '') {
      this.toastr.warning('Por favor espere que la incidencia cargue toda la información', '', { timeOut: 3000 });
      campo_vacio  = campo_vacio = + 1;
    }
    // valida si el campo viene deligenciado desde base de datos  no lo permita guardar al modificar vacio fecha inicial
    if (bloqueariniciar == 'true') {
      if ($('#actividadCierre_'+j).val() == '') {
        $('#alerta_div_actividadCierre_'+j).html(validadorcampo);
        campo_vacio = campo_vacio + 1;
      }
      else {
        $('#alerta_div_actividadCierre_'+j).html("");
      }

      if (fechainicialCierre =='') {
        $('#alerta_div_fecha_inicial_'+j).html(validadorcampo);
        campo_vacio  = campo_vacio = + 1;
      }
      else {
        $('#alerta_div_fecha_inicial_'+j).html("");
      }

      if (hora_inicio == '') {
        $('#alerta_div_hora_Inicial_'+j).html(validadorcampo);
        campo_vacio = campo_vacio + 1;
      }
      else{
        $('#alerta_div_hora_Inicial_'+j).html("");
      }
    }
   // valida si el campo viene deligenciado desde base de datos  no lo permita guardar al modificar vacio fecha final
    if (bloquearfinalizar == 'true') {
        if ($('#actividadCierre_'+j).val() == '') {
          $('#alerta_div_actividadCierre_'+j).html(validadorcampo);
          campo_vacio = campo_vacio + 1;
        }else{
          $('#alerta_div_actividadCierre_'+j).html("");
        }

        if (fechafinalcierre == '') {
          $('#alerta_div_fecha_final_'+j).html(validadorcampo);
          campo_vacio = campo_vacio + 1;
        }else{
          $('#alerta_div_fecha_final_'+j).html("");
        }

        if(horafinal == ''){
          $('#alerta_div_horafinal_'+j).html(validadorcampo);
          campo_vacio = campo_vacio + 1;
        }else {
          $('#alerta_div_horafinal_'+j).html("");
        }
    }
    if (fechainicialCierre > fechafinalcierre && bloquearfinalizar == 'true' && bloqueariniciar == 'true') {
      let alerta_div_fecha_final_mayor_ = (
        '<div class="alert alert-danger" style="padding: 5px;">La fecha Final debe ser igual o mayor a la fecha Inicial</div>'
      );

      $('#alerta_div_fecha_final_mayor_'+j).html('<div class="alert alert-danger" style="padding: 5px;">La fecha Final debe ser igual o mayor a la fecha Inicial</div>');
      $('#alerta_div_fecha_final_'+j).html(alerta_div_fecha_final_mayor_);
      campo_vacio = campo_vacio + 1;
    }
    if ($('#fechainicialCierre_'+j).val() == $('#fechafinalCierre_'+j).val()) {
      if ($('#hora_Inicial_'+j).val() > $('#horafinal_'+j).val()) {
        let alerta_div_fecha_final_mayor_ = (
          '<div class="alert alert-danger" style="padding: 5px;">La hora Final debe ser  mayor a la hora Inicial</div>'
        );

        $('#alerta_div_fecha_final_mayor_'+j).html(alerta_div_fecha_final_mayor_);
        $('#alerta_div_fecha_final_'+j).html("");
        campo_vacio = campo_vacio + 1;
      }else{
        $('#alerta_div_fecha_final_mayor_'+j).html("");
      }
    }else{
      $('#alerta_div_fecha_final_mayor_'+j).html("");
    }

    if (campo_vacio == 0) {
        let dataedit =  {
          'pqrid'              : this.nuevaprogramacion.pqrid,
          'tecnicoid'          : $('#tecnicoCierre_'+j).val(),
          'actividadCierre'    : actividadCierre,
          'logtiempoinicio'    : logtiempoinicio ? logtiempoinicio : null,
          'logtiempocierre'    : logtiempocierre,
          'fechainicialCierre' : fechainicialCierre,
          'hora_inicio'        : hora_inicio,
          'fechafinalcierre'   : fechafinalcierre,
          'horafinal'          : horafinal,
          'dataAutorizo'       : this.dataAutorizo
        }
          //EDITAR DATOS

      $('#cerrarActividad').removeAttr('disabled',false);
      this._pqr.editarActividadPqrWeb(dataedit).subscribe((resp)=>{
        if (resp.error) {
          this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
          $("#btneditActividad_"+j).removeClass('hidden');
          $('#btnsubmitEdit_'+j).addClass('hidden');
        }// .if
        else {
          this.toastr.success(resp.message, '', { timeOut: 3000 });
          this.tecnicosCierre = [];
          this.tapqrArray = [];
          this.obtenerDetallesPqr(this.nuevaprogramacion.pqrid);
        }// .else

      });
       $("#btneditActividad_"+j).removeClass('hidden');
       $('#btnsubmitEdit_'+j).addClass('hidden');
     }else{
      this.toastr.warning('Campos requeridos', '', { timeOut: 3000 });
     }
  }

  /**
   * Permite eliminar fila de la lista de actividades a cerrar
   * JMM-2019-01-09
   */
  quitarFila(i){
      this.tecnicosCierre.splice(i, 1); //elimina un elemento del arreglo segun indice
      this.mostrarBotonRefreshCierreActividad = true; //visualizar boton para deshacer cambios
  }

   /**
   * Permite refrescar fila de la lista de actividades a cerrar
   * JMM-2019-01-09
   */
  RefreshCierreActividad(){
    $('#cerrarActividad').removeAttr('disabled',false);
    this.obtenerTecnicosAsignadosPqr(this.nuevaprogramacion.detallepqrid);
  }

  /**
   * Función para obtener el listado de notas del detalle de una PQR
   * JMM-2018-07-13
   */
  obtenerNotasDetallePqr(pqrid){
    $('#privado').prop('checked', false);
    $('#nota').css('background', 'white');
    this.notaArray          = [];
    this._notadetallepqr.getNotaDetallePqr(pqrid).subscribe((resp)=>{

      if (resp.data) {
        for (let i in resp.data) {
          if(resp.data[i].estado == null || resp.data[i].estado == ''){
            this.notaArray.push(resp.data[i]);
          }
        }
      }
    });
    this.archivonotaArray = [];
    this._notadetallepqr.getArchivoNotaDetallePqr(pqrid).subscribe((resp)=>{
      if (resp.data) {
        this.archivonotaArray = resp.data;
      }
    });
  }// .obtenerNotasDetallePqr(detallepqrid)

    /**
   * Permite enviar la petición para guardar las notas
   * JMM-2018-07-12
   */
  asignarNota(){
    //ARCHIVOS ANEXOS EN LA NOTA
    let archivosanexos = this.detallepqr.archivosanexos;
    var archivos :any;

    var privado = '';
    $("#privado").each(function(){
        if ($(this).is(":checked")){
            privado  =    '1';
        } else {
            privado =    '0';
        }
      }
    );

    //If PARA GUARDAR LOS ARCHIVOS ANEXOS EN LA NOTA
    if(archivosanexos){
      archivos = {
            'detallepqrid'      : this.nuevaprogramacion.detallepqrid,
            'archivo'           : archivosanexos['archivo'][0],
            'extension'         : archivosanexos['extension'][0],
            'usuario_asigno'    : this.getUsuarioId
      }
    }

    //DATOS PARA CREAR LA NOTA
    let crear_notaDetallepqr = {
      'detallepqrid'        : this.nuevaprogramacion.detallepqrid,
      'detalle'             : this.formNotas.value.detalle,
      'usuario_asigno'      : this.getUsuarioId,
      'pqrid'               : this.formNotas.value.pqrid, //Dato para hacer el enrutamiento
      'archivos'            : archivos,
      'privado'             : privado,
    }

    //Si validacion erronea del formulario muestra mensaje
    if (!this.formNotas.value.detalle){
      this._valid.touched(this.formNotas);
      this.toastr.error('Debe digitar un texto', 'Error', { timeOut: 3000 });
    }else{
      //GUARDAR DATOS
      this._notadetallepqr.setNotaDetallePqr(crear_notaDetallepqr).subscribe((resp)=>{

        if (resp.data == 'formatoarchivoerror') {
          this.toastr.error('Formato de archivo incorrecto.', 'Error', { timeOut: 3000 });
        }
        else if (resp.error) {
          this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
        } else {
          this.toastr.success('Transacción exitosa', '', { timeOut: 3000 });

          this.detallepqr.detalle = '';
          $('#file').val('');
          this.obtenerNotasDetallePqr(this.formNotas.value.pqrid);
        }
      });
    }// .else
  }// .asignarNota()


    /**
   * Permite subir los archivos seleccionados
   * JMM-2018-07-31
   */
  subirArchivos(event:any){
    var archivos;
    if (event.target.files && event.target.files){
      var limit = 1024; //Limite de subida del archivo
      var filesAmount = event.target.files.length; //Cantidad de archivos

      //Ciclo para recorrer los archivos que se van a subir
      for (let i = 0; i < filesAmount; i++){
        var fileSize = parseInt(event.target.files[i].size);
        var siezekiloByte = fileSize/limit;

        //Validacion en caso que los archivos sean muy grandes
        if (siezekiloByte > event.target.files[i].size) {
          this.toastr.error('El archivo excede el tamañao permitido.', 'Error', { timeOut: 3000 });
        }else{
          this.urls_archivos = [];
          this.tipo_archivos = [];
          var extension = event.target.files[i].type;
          var reader = new FileReader(); //Instanciamos FileReader para recorrer los archivos y convertirlos a base64
          reader.onloadend = (event) => {
            this.urls_archivos.push(reader.result); //Se guardan los archivos codificados en base64 en un array
            this.tipo_archivos.push(extension); //Se guardan las extensiones de los archivos en un array
          }
          reader.readAsDataURL(event.target.files[i]);
        }// .else
      }// .for

      //Se almacenan los datos de los archivos a subir en un objeto
      archivos = {
        'pqrid'           : this.formNotas.value.pqrid,
        'detallepqrid'    : $('#id_detallepqr').val(),
        'archivo'         : this.urls_archivos, //Obtenemos el contenido del archivo codificado en Base64
        'extension'       : this.tipo_archivos,
        'usuario_asigno'  : this.getUsuarioId
      }

      this.detallepqr.archivosanexos = archivos;

      //Rretornar el objeto con los archivos anexos
     return   this.detallepqr.archivosanexos;
    }// .if
  }// .subirArchivos(event:any)


  colorRGB() {
		var num = Math.round(0xffffff * Math.random());
		var r = num >> 16;
		var g = num >> 8 & 255;
		var b = num & 255;
		var c = 1 >> 9;
		var A = 0.5;
		return 'rgba(' + r + ', ' + 47 + ', ' + b + ', '+ A +')';
  }

  /**
   * Formulario para validar los campos en la creación de registros
   * JMM-2018-11-07
   */
  formnuevaprogramacion(){
    let self = this;
    let requerido;
    if (this.accion == 'Crear') {
      requerido =  [Validators.required];
    }

    let requeridoAuto;
    if (this.agendaautomatica == '1') {
      if(this.accion == 'Crear'){
        requeridoAuto =  [Validators.required];
      }
    }

    this.formNuevaprogramacion = new FormGroup({
      'agendamientoid'      : new FormControl(this.nuevaprogramacion.agendamientoid),
      'fechaagendaid'       : new FormControl(this.nuevaprogramacion.fechaagendaid),
      'detallepqrid'        : new FormControl(this.nuevaprogramacion.detallepqrid),
      'alertapqrid'         : new FormControl(this.nuevaprogramacion.alertapqrid),
      'tipomantenimientoid' : new FormControl(this.nuevaprogramacion.tipomantenimientoid),
      'fecha'               : new FormControl(this.nuevaprogramacion.fecha),
      'horainicial'         : new FormControl(this.nuevaprogramacion.horainicial),
      'horainicialaux'      : new FormControl(this.nuevaprogramacion.horainicialaux),
      'horafinal'           : new FormControl(this.nuevaprogramacion.horafinal),
      'pqrid'               : new FormControl(this.nuevaprogramacion.pqrid),
      'ticket'              : new FormControl(this.nuevaprogramacion.ticket),
      'estado'              : new FormControl(this.nuevaprogramacion.estado),
      'terceroid'           : new FormControl(this.nuevaprogramacion.terceroid, [Validators.required]),
      'sucursalid'          : new FormControl(this.nuevaprogramacion.sucursalid),
      'equipoterceroid'     : new FormControl(this.nuevaprogramacion.equipoterceroid),
      'asunto'              : new FormControl(this.nuevaprogramacion.asunto, [Validators.required]),
      'tiposervicioid'      : new FormControl(this.nuevaprogramacion.tiposervicioid, [Validators.required]),
      'estadopqrid'         : new FormControl(this.nuevaprogramacion.estadopqrid, [Validators.required]),
      'tipopqrid'           : new FormControl(this.nuevaprogramacion.tipopqrid, [Validators.required]),
      'coordinadorid'       : new FormControl(this.nuevaprogramacion.coordinadorid, [Validators.required]),
      'presupuestoplaneado' : new FormControl(this.nuevaprogramacion.presupuestoplaneado),
      'descripcion'         : new FormControl(this.nuevaprogramacion.descripcion),
      'tecnicoagendamiento' : new FormControl(this.nuevaprogramacion.tecnicoagendamiento),
      'actividadid'         : new FormControl(this.nuevaprogramacion.actividadid),
      'fechafinal'          : new FormControl(this.nuevaprogramacion.fechafinal),
      'prioridadid'         : new FormControl(this.nuevaprogramacion.prioridadid),
      'valorfrecuencia'     : new FormControl(this.nuevaprogramacion.valorfrecuencia),
      'tiempo'              : new FormControl(this.nuevaprogramacion.tiempo),
      'colorhexadecimal'    : new FormControl(this.nuevaprogramacion.colorhexadecimal),
      'validadoperaciontiempo'  : new FormControl(this.nuevaprogramacion.validadoperaciontiempo),
      'operacionid'         : new FormControl(this.nuevaprogramacion.operacionid),
      'unidad_medida'       : new FormControl(this.nuevaprogramacion.unidad_medida,requeridoAuto),
      'valor_frecuencia'    : new FormControl(this.nuevaprogramacion.valor_frecuencia),
      'cantidad_inc'        : new FormControl(this.nuevaprogramacion.cantidad_inc, requerido),
      'otrocoordinadorid'   : new FormControl(this.nuevaprogramacion.otrocoordinadorid),
      'esproveedor'         : new FormControl(this.nuevaprogramacion.esproveedor),
      'contactoid'          : new FormControl(this.nuevaprogramacion.contactoid),
      'versionid'           : new FormControl(this.nuevaprogramacion.versionid),
      'nombrcomer'          : new FormControl(this.nuevaprogramacion.nombrcomer),
      'razonsocial'         : new FormControl(this.nuevaprogramacion.razonsocial),
      'nversion'            : new FormControl(this.nuevaprogramacion.nversion),
      'cambiaversionactual' : new FormControl(this.nuevaprogramacion.cambiaversionactual),
      'visibilidad'         : new FormControl(this.nuevaprogramacion.visibilidad),
      'visibpublic'       : new FormControl(this.nuevaprogramacion.visibpublic),
      'visibprivad'       : new FormControl(this.nuevaprogramacion.visibprivad),
    });

    this.formNotas = new FormGroup({
      'pqrid'           : new FormControl(this.nuevaprogramacion.pqrid),
      'detallepqrid'    : new FormControl(this.nuevaprogramacion.detallepqrid),
      'detalle'         : new FormControl(this.detallepqr.detalle),
      'files'           : new FormControl(this.detallepqr.files),
      'archivosanexos'  : new FormControl(this.detallepqr.archivosanexos)
    });
  }
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/agendamiento-app/agendamiento-app.component.ts